var _style, _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _g5, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g6, _path14, _path15, _g7, _path16, _path17, _g8, _path18, _path19, _g9, _g10, _g11, _g12, _g13, _path20, _path21, _ellipse, _path22, _g14, _path23, _path24, _ellipse2, _ellipse3, _g15, _path25, _path26, _g16, _g17, _defs, _g18, _g19, _g20, _g21, _g22, _path27, _g23, _path28, _g24, _g25, _path29, _ellipse4, _ellipse5, _g26, _path30, _path31, _ellipse6, _ellipse7, _g27, _path32, _g28, _g29, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs2, _g30, _path45, _g31, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _ellipse8, _ellipse9, _path56, _g32, _path57, _path58, _path59, _path60, _g33, _g34, _g35, _g36, _g37, _path61, _path62, _path63, _path64, _path65, _path66, _ellipse10, _ellipse11, _path67, _g38, _path68, _path69, _path70, _path71, _g39, _g40, _g41, _g42, _g43, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g44, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _defs3, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _defs4, _g45, _defs5, _g46, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg003TotalCarbon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 697.437,
    height: 106.665,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st137{opacity:.2;fill:#fff}.st148{fill:#333}.st149{fill:#1a1a1a}.st156{opacity:.3;fill:#fff}.st189{fill:#666}.st190{fill:gray}.st609{fill:#e6e6e6}.st684{fill:#252525}.st14458{fill:#151314}.st14459{fill:#2e2c2d}.st14460{fill:#787878}.st14461{fill:#898989}.st14462{fill:#b3b3b3}.st14464{fill:#da6e17}.st14466{fill:#e2f9fc}.st14467{fill:#b6d3ea}.st14468{opacity:.45;fill:#3bbb9b}.st14469{fill:#b30000}.st14470{fill:#f7931e}.st14471{fill:#303030}.st14472{fill:#cecece}.st14475{fill:#999}.st14480{opacity:.6;fill:#7bb299}.st14481{fill:#f53b2e}.st14482{fill:#700000}.st14483{fill:#d2e6e6}.st14484{fill:#aed2d2}.st14485{fill:#ccc}.st14489{fill:#141517}.st14491{fill:none;stroke:#999;stroke-width:.7053;stroke-linecap:round;stroke-miterlimit:10}.st14492{fill:#a3a3a3}.st14497{fill:#595959}.st14499{fill:#010007}.st14500{fill:#f53741}.st14506{fill:#eceefe}.st14512{opacity:.5;fill:#005952}.st14513{fill:#ffc20c}.st14514{opacity:.25;fill:#fff}.st14520{fill:#262626}")), /*#__PURE__*/React.createElement("g", {
    id: "g5902",
    transform: "translate(-1825.999 -509.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4699"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4553"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14458",
    d: "M1874.477 567.676v48.743h-14.691v-.023c-9.396-.532-16.898-11.229-16.898-24.351 0-13.118 7.502-23.815 16.898-24.347v-.023h14.691z",
    id: "path4549"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14458",
    cx: 1874.477,
    cy: 592.047,
    rx: 17.633,
    ry: 24.372,
    id: "ellipse4551"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g4559"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14458",
    d: "M1993.082 567.676v48.743h-14.691v-.023c-9.396-.532-16.898-11.229-16.898-24.351 0-13.118 7.502-23.815 16.898-24.347v-.023h14.691z",
    id: "path4555"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14458",
    cx: 1993.082,
    cy: 592.047,
    rx: 17.633,
    ry: 24.372,
    id: "ellipse4557"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2076.016 549.92-229.89 7.156 3.772 44.481s34.198 3.282 41.301 3.282h135.215l19.651-9.663h34.855l2.923-16.004z",
    id: "path4561"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g4589"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14458",
    d: "M1945.317 567.676v48.743h-14.691v-.023c-9.396-.532-16.898-11.229-16.898-24.351 0-13.118 7.502-23.815 16.898-24.347v-.023h14.691z",
    id: "path4563"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14459",
    cx: 1945.317,
    cy: 592.047,
    rx: 17.633,
    ry: 24.372,
    id: "ellipse4565"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14458",
    cx: 1945.967,
    cy: 592.047,
    rx: 11.568,
    ry: 16.771,
    id: "ellipse4567"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14460",
    d: "M1945.967 572.787c-7.337 0-13.285 8.623-13.285 19.26 0 10.637 5.948 19.26 13.285 19.26s13.285-8.623 13.285-19.26c0-10.637-5.948-19.26-13.285-19.26zm2.887 1.257c1.534.694 3.059 1.788 4.486 3.29 1.436 1.512 2.631 3.29 3.563 5.204.159.327.096.706-.135.806l-6.963 3.005c-.536.231-1.2-.469-1.214-1.279l-.181-10.576c-.01-.326.196-.531.444-.45zm-13.806 8.459c.929-1.901 2.118-3.666 3.545-5.169 1.436-1.512 2.971-2.611 4.515-3.304.264-.118.493.086.487.435l-.18 10.529c-.014.81-.678 1.51-1.214 1.279l-6.994-3.019c-.216-.093-.288-.434-.159-.751zm1.283 21.649c-.96-1.869-1.75-4.053-2.295-6.485a31.954 31.954 0 0 1-.773-7.247c0-.4.209-.653.436-.537l6.851 3.502c.527.269.781 1.401.464 2.069l-4.142 8.711c-.127.27-.373.264-.541-.013zm14.599 4.921a11.23 11.23 0 0 1-4.963 1.161c-1.775 0-3.463-.419-4.993-1.174-.261-.129-.364-.49-.217-.767l4.415-8.364c.34-.643 1.161-.643 1.5 0l4.435 8.402c.136.259.056.596-.177.742zm4.654-4.885c-.165.32-.434.35-.57.063l-4.123-8.671c-.317-.667-.063-1.799.464-2.069l6.882-3.518c.213-.109.409.106.432.472a31.89 31.89 0 0 1-.772 7.202c-.548 2.447-1.345 4.645-2.313 6.521z",
    id: "path4569"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14461",
    d: "M1945.967 572.787c-7.337 0-13.285 8.623-13.285 19.26 0 10.637 5.948 19.26 13.285 19.26s13.285-8.623 13.285-19.26c0-10.637-5.948-19.26-13.285-19.26zm0 36.031c-6.389 0-11.568-7.509-11.568-16.771s5.179-16.771 11.568-16.771c6.389 0 11.568 7.509 11.568 16.771s-5.18 16.771-11.568 16.771z",
    id: "path4571"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st609",
    d: "M1945.967 572.787c-7.337 0-13.285 8.623-13.285 19.26 0 10.637 5.948 19.26 13.285 19.26s13.285-8.623 13.285-19.26c0-10.637-5.948-19.26-13.285-19.26zm3.296 14.589-1.066-12.456c.023-.385.262-.664.527-.617 1.618.527 3.19 1.528 4.616 3.031 1.436 1.512 2.584 3.384 3.431 5.467.145.356.041.816-.221.977l-6.073 4.876c-.608.376-1.272-.324-1.214-1.278zm-14.085-4.613c.846-2.068 1.988-3.926 3.415-5.428 1.436-1.512 3.018-2.518 4.647-3.042.278-.09.548.196.573.607l2.585 12.4c.058.954-.606 1.654-1.214 1.278l-9.764-4.898c-.245-.152-.355-.568-.242-.917zm1.364 21.29c-1.095-1.805-1.961-3.954-2.506-6.386a25.912 25.912 0 0 1-.56-7.347c.027-.411.298-.695.575-.602l10.196 2.787c.644.214.897 1.347.464 2.069l-7.493 9.429c-.175.291-.482.314-.676.05zm14.388 4.699c-1.522.952-3.2 1.482-4.963 1.482-1.775 0-3.463-.535-4.993-1.499-.261-.165-.364-.625-.217-.979l6.242-10.677c.34-.821 1.161-.821 1.5 0l2.607 10.726c.137.33.057.76-.176.947zm4.441-4.664c-.189.309-.522.309-.709-.003l-3.813-9.386c-.434-.722-.18-1.854.464-2.069l6.579-2.8c.26-.087.517.157.567.536a25.891 25.891 0 0 1-.562 7.302c-.548 2.446-1.421 4.608-2.526 6.42z",
    id: "path4573"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14462",
    d: "M1950.848 594.698c-.434-.722-.18-1.854.464-2.069l2.767-1.177c-.07-1.77-.453-3.418-1.068-4.832l-2.534 2.035c-.608.375-1.272-.325-1.214-1.279l-.445-5.199a5.004 5.004 0 0 0-1.755-.32c-.599 0-1.18.109-1.735.313l1.069 5.129c.058.954-.606 1.654-1.214 1.278l-4.038-2.026c-.622 1.404-1.012 3.044-1.093 4.807l4.196 1.147c.644.214.897 1.347.464 2.069l-3.101 3.902c.741 1.319 1.705 2.363 2.809 3.013l2.579-4.411c.34-.822 1.161-.822 1.5 0l1.089 4.479c1.115-.623 2.093-1.645 2.85-2.946z",
    id: "path4575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1947.234 594.537c-.993 0-1.802-1.117-1.802-2.49 0-1.373.808-2.49 1.802-2.49s1.802 1.117 1.802 2.49c-.001 1.373-.809 2.49-1.802 2.49zm0-4.718c-.889 0-1.612 1-1.612 2.229s.723 2.228 1.612 2.228c.889 0 1.613-1 1.613-2.228-.001-1.23-.724-2.229-1.613-2.229z",
    id: "path4577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948.009 587.329c0 .592-.347 1.072-.776 1.072-.428 0-.776-.48-.776-1.072 0-.592.347-1.072.776-1.072.429-.001.776.479.776 1.072z",
    id: "path4579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.226 589.57c.407.183.63.788.498 1.351s-.57.871-.977.688c-.407-.183-.63-.788-.498-1.351s.57-.871.977-.688z",
    id: "path4581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.599 595.235c.252-.479.737-.585 1.083-.237.347.348.423 1.019.172 1.498-.251.479-.737.585-1.083.237-.347-.349-.424-1.019-.172-1.498z",
    id: "path4583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948.613 596.495c-.252-.479-.175-1.15.172-1.498.347-.348.832-.242 1.083.237.252.479.175 1.149-.172 1.498-.346.348-.831.242-1.083-.237z",
    id: "path4585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950.72 591.609c-.407.183-.845-.125-.977-.688s.091-1.168.498-1.351c.407-.183.845.125.977.688s-.09 1.168-.498 1.351z",
    id: "path4587"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g4617"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14458",
    d: "M2062.406 567.676v48.743h-14.691v-.023c-9.396-.532-16.898-11.229-16.898-24.351 0-13.118 7.502-23.815 16.898-24.347v-.023h14.691z",
    id: "path4591"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14459",
    cx: 2062.406,
    cy: 592.047,
    rx: 17.633,
    ry: 24.372,
    id: "ellipse4593"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14458",
    cx: 2063.056,
    cy: 592.047,
    rx: 11.568,
    ry: 16.771,
    id: "ellipse4595"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14460",
    d: "M2063.056 572.787c-7.337 0-13.285 8.623-13.285 19.26 0 10.637 5.948 19.26 13.285 19.26s13.285-8.623 13.285-19.26c0-10.637-5.948-19.26-13.285-19.26zm2.887 1.257c1.534.694 3.06 1.788 4.486 3.29 1.436 1.512 2.631 3.29 3.563 5.204.159.327.096.706-.135.806l-6.963 3.005c-.536.231-1.2-.469-1.214-1.279l-.181-10.576c0-.326.196-.531.444-.45zm-13.806 8.459c.929-1.901 2.118-3.666 3.545-5.169 1.436-1.512 2.971-2.611 4.515-3.304.264-.118.493.086.487.435l-.18 10.529c-.014.81-.678 1.51-1.214 1.279l-6.994-3.019c-.216-.093-.288-.434-.159-.751zm1.284 21.649c-.96-1.869-1.75-4.053-2.295-6.485a31.895 31.895 0 0 1-.772-7.247c0-.4.209-.653.436-.537l6.851 3.502c.527.269.781 1.401.464 2.069l-4.141 8.711c-.13.27-.375.264-.543-.013zm14.598 4.921a11.23 11.23 0 0 1-4.963 1.161c-1.774 0-3.462-.419-4.992-1.174-.261-.129-.364-.49-.217-.767l4.415-8.364c.34-.643 1.161-.643 1.5 0l4.435 8.402c.135.259.055.596-.178.742zm4.654-4.885c-.165.32-.434.35-.57.063l-4.123-8.671c-.317-.667-.063-1.799.464-2.069l6.882-3.518c.213-.109.409.106.433.472a31.89 31.89 0 0 1-.772 7.202c-.549 2.447-1.346 4.645-2.314 6.521z",
    id: "path4597"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14461",
    d: "M2063.056 572.787c-7.337 0-13.285 8.623-13.285 19.26 0 10.637 5.948 19.26 13.285 19.26s13.285-8.623 13.285-19.26c0-10.637-5.948-19.26-13.285-19.26zm0 36.031c-6.389 0-11.568-7.509-11.568-16.771s5.179-16.771 11.568-16.771c6.389 0 11.568 7.509 11.568 16.771s-5.179 16.771-11.568 16.771z",
    id: "path4599"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st609",
    d: "M2063.056 572.787c-7.337 0-13.285 8.623-13.285 19.26 0 10.637 5.948 19.26 13.285 19.26s13.285-8.623 13.285-19.26c0-10.637-5.948-19.26-13.285-19.26zm3.296 14.589-1.066-12.456c.024-.385.262-.664.527-.617 1.618.527 3.19 1.528 4.616 3.031 1.436 1.512 2.584 3.384 3.431 5.467.145.356.041.816-.221.977l-6.073 4.876c-.608.376-1.272-.324-1.214-1.278zm-14.084-4.613c.846-2.068 1.988-3.926 3.415-5.428 1.436-1.512 3.018-2.518 4.647-3.042.278-.09.548.196.573.607l2.585 12.4c.058.954-.606 1.654-1.214 1.278l-9.763-4.898c-.247-.152-.356-.568-.243-.917zm1.363 21.29c-1.095-1.805-1.961-3.954-2.506-6.386a25.912 25.912 0 0 1-.56-7.347c.027-.411.298-.695.575-.602l10.196 2.787c.644.214.897 1.347.464 2.069l-7.493 9.429c-.175.291-.481.314-.676.05zm14.388 4.699c-1.522.952-3.2 1.482-4.963 1.482-1.774 0-3.462-.535-4.992-1.499-.261-.165-.364-.625-.217-.979l6.242-10.677c.34-.821 1.161-.821 1.5 0l2.607 10.726c.136.33.056.76-.177.947zm4.441-4.664c-.189.309-.522.309-.709-.003l-3.813-9.386c-.434-.722-.18-1.854.464-2.069l6.579-2.8c.26-.087.517.157.567.536a25.891 25.891 0 0 1-.562 7.302c-.548 2.446-1.421 4.608-2.526 6.42z",
    id: "path4601"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14462",
    d: "M2067.938 594.698c-.434-.722-.18-1.854.464-2.069l2.767-1.177c-.07-1.77-.453-3.418-1.068-4.832l-2.534 2.035c-.608.375-1.272-.325-1.214-1.279l-.445-5.199a5.004 5.004 0 0 0-1.755-.32c-.599 0-1.18.109-1.735.313l1.069 5.129c.058.954-.606 1.654-1.214 1.278l-4.038-2.026c-.622 1.404-1.012 3.044-1.094 4.807l4.196 1.147c.644.214.897 1.347.464 2.069l-3.101 3.902c.741 1.319 1.705 2.363 2.81 3.013l2.579-4.411c.34-.822 1.161-.822 1.5 0l1.089 4.479c1.115-.623 2.093-1.645 2.85-2.946z",
    id: "path4603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2064.323 594.537c-.993 0-1.802-1.117-1.802-2.49 0-1.373.808-2.49 1.802-2.49.993 0 1.802 1.117 1.802 2.49 0 1.373-.809 2.49-1.802 2.49zm0-4.718c-.889 0-1.613 1-1.613 2.229s.723 2.228 1.613 2.228 1.612-1 1.612-2.228c0-1.23-.723-2.229-1.612-2.229z",
    id: "path4605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065.098 587.329c0 .592-.347 1.072-.776 1.072-.428 0-.776-.48-.776-1.072 0-.592.347-1.072.776-1.072.429-.001.776.479.776 1.072z",
    id: "path4607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2061.315 589.57c.407.183.63.788.498 1.351-.133.563-.57.871-.978.688-.407-.183-.63-.788-.498-1.351.133-.563.571-.871.978-.688z",
    id: "path4609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2061.688 595.235c.252-.479.737-.585 1.083-.237.347.348.424 1.019.172 1.498-.252.479-.737.585-1.083.237-.347-.349-.423-1.019-.172-1.498z",
    id: "path4611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065.702 596.495c-.252-.479-.175-1.15.171-1.498.347-.348.832-.242 1.083.237.252.479.175 1.149-.172 1.498-.345.348-.83.242-1.082-.237z",
    id: "path4613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2067.809 591.609c-.407.183-.845-.125-.978-.688-.132-.563.091-1.168.498-1.351.407-.183.845.125.978.688s-.09 1.168-.498 1.351z",
    id: "path4615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4623"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2075.081 545.557 4.149 2.074c.471.236 2.499 2.64 2.64 3.017.141.377.849 10.655.849 10.655s-7.025-9.807-7.355-10.325c-.33-.518-.283-5.421-.283-5.421z",
    id: "path4619",
    style: {
      fill: "red"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2071.642 543.468s2.26.486 3.439 2.089c1.179 1.603 2.31 5.233 2.31 5.233s1.367-.141 1.98.141c.613.283 2.499 5.469 2.781 6.836.283 1.367.943 5.045.943 5.045s-8.722-11.363-9.052-12.023c-.329-.659-2.401-7.321-2.401-7.321z",
    id: "path4621"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1900.439 547.961c9.495 1.18 31.918 1.32 39.604 1.32 9.807 0 98.443-.189 103.158-.566 4.715-.377 17.727-6.789 17.727-6.789-15.276-14.333-36.398-21.876-71.287-21.876-25.804 0-45.415 2.441-53.88 3.713-3.242 1.216-10.991 4.117-18.67 8.152-10.643 5.592-21.241 12.926-21.241 12.926s1.97 2.795 4.589 3.12zm133.144-16.03c3.408.225 8.487 10.561 8.487 10.561s-29.609-.377-30.363.377c-.754.754-.943 1.886-.943 1.886l-7.166-10.561s12.824-3.394 29.985-2.263zm-76.944 4.526c1.509-3.206 3.395-6.223 3.395-6.223s15.087 2.829 18.67 5.658c3.583 2.829 6.978 9.807 6.978 9.807l-33.192 1.509c0-.001 2.64-7.545 4.149-10.751zm-29.043-3.394c6.789-3.017 22.065-3.583 22.065-3.583s-2.516 4.285-4.526 8.487c-2.075 4.338-3.772 8.864-3.772 8.864l-39.792-.377c0-.002 19.236-10.374 26.025-13.391z",
    id: "path4625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1900.439 547.961c9.495 1.18 31.918 1.32 39.604 1.32 9.807 0 98.443-.189 103.158-.566 4.715-.377 17.727-6.789 17.727-6.789-15.276-14.333-36.398-21.876-71.287-21.876-25.804 0-45.415 2.441-53.88 3.713-3.242 1.216-10.991 4.117-18.67 8.152-10.643 5.592-21.241 12.926-21.241 12.926s1.97 2.795 4.589 3.12zm133.144-16.03c3.408.225 8.487 10.561 8.487 10.561s-29.609-.377-30.363.377c-.754.754-.943 1.886-.943 1.886l-7.166-10.561s12.824-3.394 29.985-2.263zm-76.944 4.526c1.509-3.206 3.395-6.223 3.395-6.223s15.087 2.829 18.67 5.658c3.583 2.829 6.978 9.807 6.978 9.807l-33.192 1.509c0-.001 2.64-7.545 4.149-10.751zm-29.043-3.394c6.789-3.017 22.065-3.583 22.065-3.583s-2.516 4.285-4.526 8.487c-2.075 4.338-3.772 8.864-3.772 8.864l-39.792-.377c0-.002 19.236-10.374 26.025-13.391z",
    id: "path4627"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g4633"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1897.03 544.039s-.928-4.155-1.399-4.155-3.725.613-4.055.754c-.33.141-.943.754-1.084.943-.141.189-.094 1.792 0 1.98.094.189 1.886 1.886 1.886 1.886h3.476z",
    id: "path4629"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14464",
    d: "m1890.474 543.51.017.004h1.768c.259 0 .094-1.579-.165-1.627-.259-.047-1.603-.306-1.603-.306-.132.176-.099 1.597-.017 1.929z",
    id: "path4631"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2086.938 588.449c-.163-.955-.975-2.227-.975-2.227s-.163-17.357-.488-18.312c-.325-.955-2.924-6.682-3.899-8.273-.975-1.591-7.149-9.387-7.149-9.387s-.812-4.296-1.3-5.409c-.487-1.114-2.112-1.75-2.112-1.75s-22.173-13.683-24.4-14.796c-2.227-1.114-14.416-7.637-42.099-9.705-27.683-2.068-64.754 3.5-67.299 4.614-.292.128-1.086.42-2.253.859a352.67 352.67 0 0 1 7.781-.806 353.599 353.599 0 0 1 40.861-1.383 137.065 137.065 0 0 0-24.642 24.768 947.406 947.406 0 0 0-63.113-1.801s-32.138 1.909-43.753 6.046c-11.614 4.137-17.66 13.523-17.66 13.523l-.796 3.818s-5.25 4.137-7.159 7.478c-.403.704 2.227 15.274 2.227 15.274s-2.864 2.705-2.705 3.818c.159 1.114 2.227 6.523 2.227 6.523h93.711s-.797-38.025 24.182-38.025c17.979 0 19.638 22.19 19.251 32.453-.116 3.087-.796 5.095-.796 5.095h76.864s5.534-2.069 6.564-8.591c1.76-11.152 9.972-26.888 21.056-26.888 14.298 0 11.853 29.767 11.853 29.767s4.882-2.546 5.044-2.705c.162-.159 0-2.387 0-2.387s1.14-.636.977-1.591zm-46.306-40.586h-73.345s11.455-21.319 20.683-24.183c9.228-2.864 30.547-2.386 45.821 3.5 15.274 5.887 23.865 14.478 23.865 14.478s-12.41 6.205-17.024 6.205zm-106.325-23.553z",
    id: "path4635",
    style: {
      fill: "#0085c7"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1830.599 573.924c3.52 2.64 5.281 7.292 5.281 7.292h24.139c3.269-3.898 7.583-5.594 11.229-6.223 3.646-.629 31.759-5.831 35.153-7.717 3.395-1.886 15.643-12.54 15.643-12.54s-12.113 1.712-15.381 2.215c-3.269.503-28.288 4.526-29.671 4.526h-40.252c-1.523 1.731-2.3 2.933-2.3 2.933l-.796 3.818c-.001 0-3.674 4.438-3.045 5.696z",
    id: "path4637"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st14466",
    d: "M1875.231 573.044s4.401-7.418 8.549-9.555c4.149-2.137 33.82-6.412 33.82-6.412s-8.927 7.921-12.824 9.681c-3.897 1.759-29.545 6.286-29.545 6.286z",
    id: "path4639"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1870.239 601.321c-1.703-3.201-7.676-13.945-11.1-13.945h-24.014c-1.284 0-1.931 10.744-2.095 13.945z",
    id: "path4641"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1861.904 585.113s1.634-4.652 4.023-5.281c2.389-.629 27.408-5.658 30.049-3.772 2.64 1.886 11.064 15.087 11.064 15.087s-4.903 6.538-7.166 7.418c-2.263.88-23.762.88-25.774.88-2.012 0-12.07-14.583-12.196-14.332z",
    id: "path4643"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1828.711 590.979s-.879 1.803-1.256 2.683c-.377.88.377 3.52.377 3.52h3.269c.88 0 3.143-12.195 3.143-12.195s-.629-4.023-1.257-4.652c-.629-.629-6.504-4.63-6.504-4.63l-.039.465c.064 2.603 2.267 14.809 2.267 14.809z",
    id: "path4645"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M1963.365 575.307s1.76 4.526 2.263 9.178c.503 4.652 1.006 10.812.377 14.333l81.17-6.286.126-1.634s-4.1-1.383-6.112-1.257c-2.012.126-6.789.377-6.789.377s-2.515-2.263-6.538-2.389c7.544-2.892 15.339-11.693 15.339-11.693s-13.956 3.017-30.552 6.412-32.186 4.903-35.58 6.915c-3.395 2.012-6.538 6.161-6.538 6.161s-1.886-.126-2.137-2.766c-.251-2.64-1.131-8.047-2.263-11.567-1.073-3.34-2.766-5.784-2.766-5.784z",
    id: "path4647"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14467",
    d: "M1917.601 557.076s-6.388.92-13.649 2.12c1.123.065 5.383.161 5.603 1.149.252 1.132-3.646 4.652-5.029 5.406-1.383.754-23.385 5.783-24.894 4.778-.752-.501-.848-1.627-.755-2.63l-.001.001c-.125.151-.247.303-.368.454l-.063.08a48.982 48.982 0 0 0-.369.472l-.283.371-.058.077-.307.414c0 .006-.01.012-.013.018a45.35 45.35 0 0 0-.616.862c0 .004 0 .007-.01.011l-.26.376-.035.051-.213.314-.039.058-.198.299c-.01.01-.013.02-.019.03-.213.323-.387.597-.518.806 0 .008-.01.015-.015.023l-.098.158c-.01.011-.014.022-.021.033l-.067.109c0 .006-.01.014-.012.02l-.065.108s.647-.114 1.749-.313l.589-.106a937.102 937.102 0 0 0 9.051-1.689l1.277-.247.645-.126 1.298-.256.65-.129a444.831 444.831 0 0 0 4.482-.918 208.412 208.412 0 0 0 2.409-.521 161.882 161.882 0 0 0 3.222-.746c1.948-.476 3.443-.904 4.174-1.234 3.896-1.762 12.822-9.682 12.823-9.683z",
    id: "path4649"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M1891.45 574.175s4.275-.754 5.281-.126c1.006.629 2.263 2.263 2.263 2.263l24.014-3.143s8.172-15.339 22.379-15.213c14.207.126 18.482 10.938 18.482 10.938s2.515 1.006 8.172.503c5.658-.503 54.817-5.658 62.989-6.161 8.172-.503 20.493.377 20.493.377s9.817-4.903 16.155-2.892c6.338 2.012 7.373 6.663 7.373 6.663s1.94-3.269 1.811-7.544l-7.502-9.304-.776-2.012s-16.935-.126-26.364 2.515c-11.818.88-44.884 4.149-55.319 5.029-10.435.88-24.517-5.658-38.975-5.155-14.458.503-24.391.377-32.563 6.663-8.172 6.286-10.309 8.424-12.573 9.807-2.263 1.383-21.122 5.406-21.122 5.406s2.892-.377 4.4.126c1.508.506 1.382 1.26 1.382 1.26z",
    id: "path4651"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14464",
    d: "M1920.901 569.02s2.64 2.829 3.677 2.829h4.102l4.055-4.573s-10.089.283-10.561.283c-.471 0-1.273 1.461-1.273 1.461z",
    id: "path4653"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g4659"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14468",
    d: "M1967.287 547.863s11.455-21.319 20.683-24.183c9.228-2.864 30.547-2.386 45.821 3.5 15.274 5.887 23.865 14.478 23.865 14.478s-12.41 6.205-17.024 6.205h-73.345z",
    id: "path4655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040.686 530.211a80.613 80.613 0 0 0-6.895-3.033c-5.756-2.218-12.375-3.666-18.878-4.458a99.521 99.521 0 0 0-6.148-.558 95.265 95.265 0 0 0-5.884-.185c-6.065 0-11.376.607-14.91 1.701-9.23 2.867-20.685 24.185-20.685 24.185h73.346c1.411 0 3.549-.581 5.839-1.384 5.201-1.829 11.183-4.82 11.183-4.82s-6.03-6.032-16.968-11.448zm-70.167 15.766c4.028-6.853 11.979-18.625 18.01-20.496 3.364-1.045 8.46-1.618 14.352-1.618 2.169 0 4.364.079 6.552.23a92.703 92.703 0 0 1 3.357 13.269c.536 3.04.886 5.922 1.105 8.615zm75.319-1.282c-2.176.77-4.07 1.282-5.205 1.282h-19.025a109.248 109.248 0 0 0-2.135-9.727 112.125 112.125 0 0 0-3.76-11.519c6.37.849 12.439 2.297 17.399 4.209a79.43 79.43 0 0 1 8.498 3.862c.158.087.317.17.475.253v.004a61.966 61.966 0 0 1 1.731 4.145 60.942 60.942 0 0 1 2.248 7.412c-.075.026-.151.056-.226.079z",
    id: "path4657"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M1863.602 570.278s2.766-.629 4.715-1.257c1.949-.628 4.149-1.886 4.149-1.886l-2.577-3.143h-30.228c-.754 0-1.697 1.132-1.697 1.132h26.771c.566 0 2.263 2.137 2.452 2.829.189.692-3.585 2.325-3.585 2.325z",
    id: "path4661"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M1868.756 574.647c-3.394.4-7.638.912-10.372.912h-23.322c-.817 0-2.829-.817-2.829-.817l2.074 2.515s-.629-1.006.817-1.006h24.768c2.012 0 3.049 1.194 3.049 1.194.585-.436 1.359-.825 2.137-1.257a18.18 18.18 0 0 1 3.678-1.541z",
    id: "path4663"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g4669"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14468",
    d: "M1918.733 545.007c13.835.268 27.254.831 40.232 1.635a137.065 137.065 0 0 1 24.642-24.768 353.599 353.599 0 0 0-40.861 1.383c-2.63.242-5.222.513-7.781.806-3.599 1.355-10.765 4.118-17.872 7.852-10.643 5.592-21.241 12.926-21.241 12.926a943.14 943.14 0 0 1 22.881.166z",
    id: "path4665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975.117 521.77c-10.278 0-21.088.449-32.37 1.486a336.84 336.84 0 0 0-7.781.807c-.615.234-1.335.505-2.146.818 6.536-.66 20.341-1.577 46.585-1.577a139.127 139.127 0 0 0-10.704 9.833 138.386 138.386 0 0 0-10.44 11.949c-33.671-1.939-53.401-1.43-61.231-1.049-.758.513-1.177.803-1.177.803a944.92 944.92 0 0 1 22.88.166c13.835.268 27.255.83 40.234 1.633a137.517 137.517 0 0 1 10.81-12.447c4.805-4.9 9.516-8.969 13.831-12.322-2.788-.062-5.621-.1-8.491-.1z",
    id: "path4667"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M1928.288 545.887h-32.437s-30.048 3.175-39.352 5.909c-9.304 2.735-11.63 4.149-11.63 4.149l4.086-3.332s-2.923 1.572-5.532 3.395-5.469 4.778-5.469 4.778h5.783s-4.526-1.194-2.012-2.64c2.515-1.446 9.178-4.149 20.368-5.406 11.19-1.257 29.923-.44 29.923-.44s-4.023 1.383-7.104 2.389c-3.08 1.006-6.224 3.017-6.224 3.017s6.852-2.515 14.836-4.652c7.984-2.138 34.764-7.167 34.764-7.167z",
    id: "path4671"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "m1921.247 578.701-2.515 8.047s-5.532 3.395-5.658 4.149c-.126.754 7.292 2.64 7.544 3.269.251.629.754 5.783.754 5.783h-20.619s9.681-6.915 9.932-8.675c.251-1.76-.503-3.269 2.263-5.406 2.766-2.137 8.299-7.167 8.299-7.167z",
    id: "path4673"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g4679"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14462",
    d: "M2038.424 595.281h-65.503c-2.315 0-2.83-.287-3.245-1.808-.236-.864-.406-11.977-.588-25.317-.074-5.4-.132-9.664-.175-10.309-.123-1.847-1.839-9.853-1.857-9.933a.236.236 0 0 1 .461-.099c.071.331 1.74 8.12 1.866 10.001.044.658.102 4.928.176 10.334.132 9.686.332 24.324.57 25.2.338 1.24.576 1.46 2.79 1.46h65.503c1.239 0 4.041-3.563 7.497-9.532 3.087-5.332 6.251-11.848 7.873-16.214 3.287-8.852 5.14-19.169 5.14-20.16 0-.54-3.257-2.896-6.274-4.768a.236.236 0 0 1 .249-.401c1.524.946 6.497 4.114 6.497 5.169 0 1.005-1.863 11.422-5.169 20.324-1.63 4.388-4.807 10.933-7.906 16.286-2.58 4.456-6.046 9.767-7.905 9.767z",
    id: "path4675"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14462",
    d: "M2020.823 594.862a.236.236 0 0 1-.216-.141c-.042-.096-1.026-2.405-1.026-7.177 0-.775.399-1.759.862-2.898.54-1.331 1.152-2.84 1.152-4.191v-27.253c0-.764-1.438-4.041-1.992-5.239a.238.238 0 0 1 .115-.313.237.237 0 0 1 .313.115c.208.451 2.035 4.43 2.035 5.436v27.253c0 1.443-.63 2.997-1.187 4.368-.425 1.048-.827 2.038-.827 2.721 0 4.661.977 6.966.987 6.989a.233.233 0 0 1-.122.31.227.227 0 0 1-.094.02z",
    id: "path4677"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m2008.25 553.933 12.195-1.006s-.251 4.652-2.515 4.652h-6.915c-1.76 0-2.765-3.646-2.765-3.646z",
    id: "path4681"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m2044.459 551.042 12.195-1.006s-.251 4.652-2.514 4.652h-6.915c-1.761 0-2.766-3.646-2.766-3.646z",
    id: "path4683"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g4689"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14466",
    d: "M1834.439 564.41s1.645 2.916 2.651 8.071l-5.577-1.292s-.909-2.169 0-4.054c.909-1.886 2.926-2.725 2.926-2.725z",
    id: "path4685"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14467",
    d: "M1834.439 570.278c-.752.249-2.358.069-3.317-.902.066 1.031.391 1.814.391 1.814l5.577 1.292c-1.006-5.155-2.651-8.071-2.651-8.071s.948 5.552 0 5.867z",
    id: "path4687"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g4695"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1972.405 539.424s-.867 3.848-.364 4.275c.503.427 3.173.301 3.173.301s.284-2.766 1.165-3.395 1.949-.817 1.949-.817h14.755c.961 0 3.664 1.664 4.104 1.932.44.268-.126 3.285-.503 3.914s-4.275 3.583-5.658 3.583h-14.521c-.755 0-.693-1.355-1.462-1.355h-7.755a122.265 122.265 0 0 1 5.117-8.438z",
    id: "path4691"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14464",
    d: "M1997.186 541.721h-11.127c-1.572 0-2.2 3.914-1.634 3.914h12.258c.377-.628.943-3.646.503-3.914z",
    id: "path4693"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g4998"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g4707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2025.819 542.869s-8.071.023-8.571-.578c-.02-.026-.043-.055-.063-.09-.249-.396-.497-1.355-.607-2.309-.104-.913-.084-1.82.188-2.225.104-.153.312-.321.598-.491 1.306-.795 4.187-1.696 5.375-2.014.644-.171 1.326 1.341 1.884 3.069.694 2.15 1.196 4.638 1.196 4.638z",
    id: "path4701"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14469",
    d: "M2024.623 538.231c-1.939.185-6.724.61-7.184.303-.321-.214-.225-.841-.075-1.358 1.306-.795 4.187-1.696 5.375-2.014.645-.17 1.326 1.341 1.884 3.069z",
    id: "path4703"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14470",
    d: "M2017.922 541.907c-.147.147-.436.24-.737.295-.249-.396-.497-1.355-.607-2.309.572.038 1.344.165 1.633.569.483.674.095 1.058-.289 1.445z",
    id: "path4705"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g4713"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2030.302 591.635c.064 13.608-6.818 24.672-15.376 24.713-2.486.012-4.834-.908-6.923-2.55-5.103-4.016-8.635-12.36-8.68-22.017-.045-9.654 3.408-18.031 8.473-22.095 2.074-1.661 4.413-2.603 6.899-2.615 8.558-.04 15.543 10.96 15.607 24.564z",
    id: "path4709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2008.003 613.798c2.089 1.642 4.437 2.561 6.923 2.55l-15.149.071c-8.554.04-15.543-10.959-15.607-24.567-.064-13.604 6.821-24.669 15.376-24.709l15.149-.071c-2.486.012-4.825.953-6.899 2.615-5.065 4.064-8.519 12.44-8.473 22.095.045 9.656 3.577 18 8.68 22.016z",
    id: "path4711"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g4719"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2142.927 591.635c.064 13.608-6.818 24.672-15.376 24.713-2.486.012-4.834-.908-6.923-2.55-5.103-4.016-8.635-12.36-8.68-22.017-.045-9.654 3.408-18.031 8.473-22.095 2.074-1.661 4.413-2.603 6.899-2.615 8.559-.04 15.544 10.96 15.607 24.564z",
    id: "path4715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2120.629 613.798c2.089 1.642 4.437 2.561 6.923 2.55l-15.149.071c-8.554.04-15.543-10.959-15.607-24.567-.064-13.604 6.821-24.669 15.376-24.709l15.149-.071c-2.486.012-4.825.953-6.899 2.615-5.065 4.064-8.519 12.44-8.473 22.095.045 9.656 3.577 18 8.68 22.016z",
    id: "path4717"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2221.738 563.77s1.709 16.159 1.276 21.721c-.433 5.562-1.862 8.637-1.862 8.637s-48.315 9.423-53.516 9.423h-152.892c-5.201 0-10.403-7.513-10.403-7.513V563.77z",
    id: "path4721"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4796"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14471",
    d: "M2108.322 591.635c.064 13.608-6.818 24.672-15.376 24.713-2.486.012-4.834-.908-6.923-2.55-5.103-4.016-8.635-12.36-8.68-22.017-.045-9.654 3.408-18.031 8.473-22.095 2.074-1.661 4.413-2.603 6.899-2.615 8.558-.04 15.543 10.96 15.607 24.564z",
    id: "path4723"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-2.755 9.832)",
    className: "st14472",
    cx: 2092.832,
    cy: 591.71,
    rx: 12.277,
    ry: 19.528,
    id: "ellipse4725"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 3994.446,
    cy: 608.363,
    r: 17.521,
    gradientTransform: "matrix(.6287 -.003 .0047 1 -421.335 -4.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop4727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop4729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop4731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop4733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop4735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop4737"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    d: "M2103.847 591.658c.046 9.677-4.849 17.544-10.933 17.573-6.083.029-11.052-7.793-11.097-17.47-.045-9.677 4.849-17.544 10.933-17.573 6.083-.028 11.052 7.793 11.097 17.47z",
    id: "path4740"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2098.139 591.685c.022 4.662-2.336 8.452-5.267 8.466-2.931.014-5.324-3.754-5.346-8.416-.022-4.662 2.336-8.452 5.267-8.466 2.93-.014 5.324 3.754 5.346 8.416z",
    id: "path4742"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g4792"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2092.68 581.354 1.276 10.351-2.73-9.021-4.994-5.047a10.99 10.99 0 0 1 2.272-2.072z",
    id: "path4744"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2096.353 580.57-2.397 11.134.492-11.125-3.185-6.224a7.187 7.187 0 0 1 1.488-.166c.504-.002 1 .05 1.488.152z",
    id: "path4746"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2099.302 577.575.295 5.069-5.641 9.061 4.173-10.379-1.121-5.801c.818.535 1.587 1.226 2.294 2.05z",
    id: "path4748"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2092.68 581.354 1.276 10.351-2.73-9.021a7 7 0 0 1 1.454-1.33z",
    id: "path4750"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2096.353 580.57-2.397 11.134.492-11.125c.311-.067.629-.104.953-.106.323-.001.64.033.952.097z",
    id: "path4752"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2099.596 582.644-5.641 9.061 4.173-10.379a7.073 7.073 0 0 1 1.468 1.318z",
    id: "path4754"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2088.454 590.216 5.502 1.488-5.488 1.542-6.539.882a28.226 28.226 0 0 1-.022-4.733z",
    id: "path4756"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2089.742 585.066 4.213 6.638-5.035-4.31-6.284-2.399a21.763 21.763 0 0 1 1.279-3.639z",
    id: "path4758"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2093.956 591.704-4.151 6.677-5.792 3.764a21.837 21.837 0 0 1-1.313-3.624l6.263-2.46z",
    id: "path4760"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2088.963 596.061 4.993-4.357-4.151 6.677a13.74 13.74 0 0 1-.842-2.32z",
    id: "path4762"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2088.454 590.216 5.502 1.488-5.488 1.542a18.355 18.355 0 0 1-.071-1.516c0-.514.018-1.018.057-1.514z",
    id: "path4764"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2089.742 585.066 4.213 6.638-5.035-4.31c.217-.83.492-1.612.822-2.328z",
    id: "path4766"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2091.31 600.751 2.646-9.047-1.178 10.365-4.12 5.829a11.051 11.051 0 0 1-2.294-2.053z",
    id: "path4768"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2094.554 602.825-.598-11.12 2.503 11.111-2.056 6.249a7.187 7.187 0 0 1-1.488.166c-.504.002-1-.05-1.488-.152z",
    id: "path4770"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "M2099.434 605.783c-.698.827-1.459 1.526-2.272 2.072l1.065-5.814-4.271-10.336 5.726 9.007z",
    id: "path4772"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2098.226 602.041-4.271-10.336 5.726 9.007a7.026 7.026 0 0 1-1.455 1.329z",
    id: "path4774"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2094.554 602.825-.598-11.12 2.503 11.111a4.653 4.653 0 0 1-.953.106 4.645 4.645 0 0 1-.952-.097z",
    id: "path4776"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2091.31 600.751 2.646-9.047-1.178 10.365a7.128 7.128 0 0 1-1.468-1.318z",
    id: "path4778"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2101.164 598.328-7.208-6.624 8.03 4.296 1.043 2.423a21.946 21.946 0 0 1-1.281 3.639z",
    id: "path4780"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2101.944 587.333-7.988 4.371 7.146-6.692.549-3.739a22.021 22.021 0 0 1 1.315 3.624z",
    id: "path4782"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2102.453 593.178-8.497-1.474 8.483-1.557 1.298-.857a28.226 28.226 0 0 1 .022 4.733z",
    id: "path4784"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2101.944 587.333-7.988 4.371 7.146-6.692c.337.714.619 1.493.842 2.321z",
    id: "path4786"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2102.453 593.178-8.497-1.474 8.483-1.557a17.927 17.927 0 0 1 .014 3.031z",
    id: "path4788"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2101.164 598.328-7.208-6.624 8.03 4.296a13.868 13.868 0 0 1-.822 2.328z",
    id: "path4790"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2086.023 613.798c2.089 1.642 4.437 2.561 6.923 2.55l-15.149.071c-8.554.04-15.543-10.959-15.607-24.567-.064-13.604 6.822-24.669 15.376-24.709l15.149-.071c-2.486.012-4.825.953-6.899 2.615-5.065 4.064-8.519 12.44-8.473 22.095.045 9.656 3.577 18 8.68 22.016z",
    id: "path4794"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4871"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14471",
    d: "M2220.948 591.635c.064 13.608-6.818 24.672-15.376 24.713-2.486.012-4.834-.908-6.923-2.55-5.103-4.016-8.635-12.36-8.68-22.017-.045-9.654 3.408-18.031 8.473-22.095 2.074-1.661 4.413-2.603 6.899-2.615 8.558-.04 15.543 10.96 15.607 24.564z",
    id: "path4798"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-2.754 10.361)",
    className: "st14472",
    cx: 2205.458,
    cy: 591.71,
    rx: 12.277,
    ry: 19.528,
    id: "ellipse4800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 4173.583,
    cy: 608.9,
    r: 17.521,
    gradientTransform: "matrix(.6287 -.003 .0047 1 -421.335 -4.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop4802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop4804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop4806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop4808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop4810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop4812"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_22_)"
    },
    d: "M2216.473 591.658c.045 9.677-4.849 17.544-10.933 17.573-6.083.029-11.052-7.793-11.098-17.47-.046-9.677 4.85-17.544 10.933-17.573 6.084-.028 11.053 7.793 11.098 17.47z",
    id: "path4815"
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-2.755 10.364)",
    cx: 2205.458,
    cy: 591.71,
    rx: 5.307,
    ry: 8.441,
    id: "ellipse4817"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g4867"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2205.306 581.354 1.276 10.351-2.731-9.021-4.993-5.047a10.99 10.99 0 0 1 2.272-2.072z",
    id: "path4819"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2208.979 580.57-2.397 11.134.492-11.125-3.185-6.224a7.187 7.187 0 0 1 1.488-.166c.504-.002 1 .05 1.488.152z",
    id: "path4821"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2211.927 577.575.295 5.069-5.641 9.061 4.173-10.379-1.121-5.801c.819.535 1.588 1.226 2.294 2.05z",
    id: "path4823"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2205.306 581.354 1.276 10.351-2.731-9.021c.447-.534.935-.98 1.455-1.33z",
    id: "path4825"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2208.979 580.57-2.397 11.134.492-11.125c.311-.067.629-.104.953-.106.323-.001.64.033.952.097z",
    id: "path4827"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2212.222 582.644-5.641 9.061 4.173-10.379a7.073 7.073 0 0 1 1.468 1.318z",
    id: "path4829"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2201.079 590.216 5.502 1.488-5.488 1.542-6.539.882a28.226 28.226 0 0 1-.022-4.733z",
    id: "path4831"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2202.368 585.066 4.213 6.638-5.035-4.31-6.284-2.399a21.763 21.763 0 0 1 1.279-3.639z",
    id: "path4833"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2206.582 591.704-4.151 6.677-5.792 3.764a21.837 21.837 0 0 1-1.313-3.624l6.263-2.46z",
    id: "path4835"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2201.589 596.061 4.993-4.357-4.151 6.677a13.74 13.74 0 0 1-.842-2.32z",
    id: "path4837"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2201.079 590.216 5.502 1.488-5.488 1.542a18.355 18.355 0 0 1-.071-1.516c-.001-.514.019-1.018.057-1.514z",
    id: "path4839"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2202.368 585.066 4.213 6.638-5.035-4.31c.217-.83.492-1.612.822-2.328z",
    id: "path4841"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2203.936 600.751 2.646-9.047-1.178 10.365-4.12 5.829a11.047 11.047 0 0 1-2.293-2.053z",
    id: "path4843"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2207.18 602.825-.598-11.12 2.503 11.111-2.056 6.249a7.187 7.187 0 0 1-1.488.166c-.504.002-1-.05-1.488-.152z",
    id: "path4845"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "M2212.06 605.783c-.698.827-1.459 1.526-2.272 2.072l1.065-5.814-4.271-10.336 5.725 9.007z",
    id: "path4847"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2210.852 602.041-4.271-10.336 5.725 9.007a6.996 6.996 0 0 1-1.454 1.329z",
    id: "path4849"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2207.18 602.825-.598-11.12 2.503 11.111a4.653 4.653 0 0 1-.953.106 4.638 4.638 0 0 1-.952-.097z",
    id: "path4851"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2203.936 600.751 2.646-9.047-1.178 10.365a7.128 7.128 0 0 1-1.468-1.318z",
    id: "path4853"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2213.79 598.328-7.208-6.624 8.03 4.296 1.043 2.423a21.946 21.946 0 0 1-1.281 3.639z",
    id: "path4855"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2214.57 587.333-7.988 4.371 7.146-6.692.549-3.739a22.021 22.021 0 0 1 1.315 3.624z",
    id: "path4857"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2215.079 593.178-8.497-1.474 8.483-1.557 1.298-.857a28.226 28.226 0 0 1 .022 4.733z",
    id: "path4859"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2214.57 587.333-7.988 4.371 7.146-6.692c.337.714.619 1.493.842 2.321z",
    id: "path4861"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2215.079 593.178-8.497-1.474 8.483-1.557c.044.495.068 1.002.071 1.516 0 .516-.018 1.02-.057 1.515z",
    id: "path4863"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2213.79 598.328-7.208-6.624 8.03 4.296a13.868 13.868 0 0 1-.822 2.328z",
    id: "path4865"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2198.649 613.798c2.089 1.642 4.437 2.561 6.923 2.55l-15.149.071c-8.554.04-15.543-10.959-15.607-24.567-.064-13.604 6.821-24.669 15.376-24.709l15.149-.071c-2.486.012-4.825.953-6.899 2.615-5.065 4.064-8.519 12.44-8.473 22.095.045 9.656 3.577 18 8.68 22.016z",
    id: "path4869"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14469",
    d: "M2223.881 572.56c-.434-5.346-.867-14.376-1.902-17.314-2.4-6.808-6.068-14.352-6.742-15.267-.674-.915-1.469-1.156-1.469-1.156s-3.468-5.129-8.741-9.536-11.775-7.73-11.775-7.73c-6.502-5.49-20.011-9.175-44.934-10.836-24.923-1.662-39.732-.939-59.165.361-19.433 1.3-28.969 5.201-30.269 5.707-.156.061-.82.48-1.858 1.166 2.678-.453 8.709-1.2 21.652-1.888 20.372-1.084 37.421.867 37.421.867s-6.502 7.946-10.258 12.425c-3.756 4.479-9.391 12.57-9.391 12.57s-35.109-.722-49.196-.578c-14.087.144-25.573.939-25.573.939s-9.415 1.252-25.718 4.84c-16.302 3.588-18.205 6.718-18.205 6.718l-7.007 12.859s-1.011 1.011-1.445 2.167c-.434 1.156 0 7.513 0 12.136 0 4.623-1.589 10.692-1.589 11.992 0 1.3 3.901 9.102 3.901 9.102h5.851s.289-16.471 2.986-16.471h31.786c5.201 0 13.292 16.471 13.292 16.471h45.849s4.623-41.177 24.562-36.265c19.938 4.912 12.136 34.387 12.136 34.387l82.499-1.589s3.757-31.497 19.361-31.208c15.604.289 11.213 26.698 11.213 26.698s-.377.465.634-.546c1.011-1.011 3.829-10.403 3.829-11.992 0-1.588-1.302-3.683-1.735-9.029zm-93.119-41.827c-1.156.722-1.3 3.034-1.3 3.034s-2.023-13.292.433-13.726c2.456-.433 21.672-.289 31.93-.289 6.775 0 15.627.945 20.86 1.587l11.344 8.672c-8.661.006-62.224.07-63.267.722z",
    id: "path4873"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g4879"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2078.677 516.068c-12.943.688-18.974 1.435-21.652 1.888-7.578 5.004-35.346 24.335-35.346 24.335s11.486-.795 25.573-.939c14.087-.145 49.196.578 49.196.578s.94-1.35 2.308-3.251l-.698.043 4.531-6.111s-1.3-2.167-2.601-2.167c-1.149 0-12.23-.451-16.185.042l.071-.213c1.449-4.271 3.206-8.141 4.156-10.128 6.056.603 11.444 1.429 14.261 2.556 1.235.494 2.448 1.133 3.623 1.862l.834 3.711c3.807-4.565 9.35-11.339 9.35-11.339s-17.049-1.951-37.421-.867zm-8.206 23.719c-17.06.363-38.968.645-38.968.645s4.811-5.361 12.528-11.207c7.717-5.846 14.55-10.648 14.55-10.648s12.051.191 23.787 1.077c-1.531 2.223-4.335 6.438-6.798 10.934a929.123 929.123 0 0 1-5.099 9.199z",
    id: "path4875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194.029 530.011c-8.661.006-62.224.07-63.267.722-1.156.722-1.3 3.034-1.3 3.034s-2.023-13.292.433-13.726c2.456-.433 21.672-.289 31.93-.289 6.775 0 15.627.945 20.86 1.587a18.567 18.567 0 0 0-1.066-.576c-4.551-2.24-18.855-4.623-27.379-5.201-8.524-.578-22.106-1.084-29.185 1.951-7.079 3.035-19.794 23.189-19.794 23.189s.433 1.734 1.228 2.384c.795.65 15.459.289 26.729.072 11.27-.217 41.394-3.395 52.23-4.479 10.836-1.084 13.437-2.312 13.437-2.312-.334-1.587-2.304-3.938-4.856-6.356z",
    id: "path4877"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "g4885"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14475",
    d: "M2119.065 597.205c-1.774 0-2.987-.335-3.698-1.02-.53-.51-.787-1.22-.787-2.17 0-1.038-.683-12.394-1.285-22.413-.495-8.224-.962-15.993-1.026-17.602-.141-3.54-2.419-8.347-2.442-8.395a.149.149 0 0 1 .068-.193.145.145 0 0 1 .193.068c.023.049 2.326 4.908 2.47 8.508.064 1.607.531 9.374 1.026 17.597.632 10.513 1.286 21.384 1.286 22.43 0 .867.229 1.509.699 1.962.725.699 2.052 1.003 4.063.928.611-.016 61.011-1.591 64.438-1.734 3.174-.132 5.103-2.279 6.658-7.41.222-.732.442-1.621.697-2.65 1.379-5.572 3.686-14.89 11.869-20.789.148-6.701.161-19.631-.843-21.081-1.273-1.839-6.519-5.911-6.572-5.952a.145.145 0 0 1 .177-.229c.217.168 5.335 4.141 6.633 6.016 1.312 1.895.91 20.532.892 21.324v.072l-.059.042c-8.144 5.835-10.442 15.119-11.815 20.666-.256 1.033-.477 1.926-.7 2.664-1.576 5.202-3.646 7.479-6.923 7.616-3.429.143-63.831 1.718-64.441 1.734a14.32 14.32 0 0 1-.577.011z",
    id: "path4881"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14475",
    d: "M2161.101 596.101a.145.145 0 0 1-.142-.174c.019-.09 1.871-9.008 1.591-10.408-.123-.612-.484-1.463-.866-2.363-.499-1.175-1.015-2.39-1.015-3.155 0-.444.201-3.754.455-7.944.49-8.061 1.229-20.243 1.134-21.956-.146-2.619-2.547-4.487-3.701-5.384-1.349-1.049-1.079-3.495-1.066-3.598a.144.144 0 1 1 .286.033c0 .024-.264 2.388.957 3.337 1.095.852 3.659 2.846 3.812 5.596.096 1.73-.615 13.439-1.134 21.989-.254 4.185-.455 7.491-.455 7.926 0 .707.504 1.894.992 3.042.389.915.755 1.778.884 2.42.292 1.457-1.515 10.154-1.592 10.523a.142.142 0 0 1-.14.116z",
    id: "path4883"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4934"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_399_",
    d: "M1980.212 556.884s7.417 3.179 17.338 3.179c16.957 0 39.251-3.227 39.251-3.227s-10.595 17.145-18.686 18.686c-8.091 1.541-14.255 1.734-20.998 1.349-7.116-.407-10.734-1.406-12.425-2.071-4.046-1.59-4.48-17.916-4.48-17.916z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_399_",
    style: {
      overflow: "visible"
    },
    id: "use4890",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_399_",
    style: {
      overflow: "visible"
    },
    id: "use4892",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_24_)",
    id: "g4932"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 2007.279,
    y1: 557.68,
    x2: 2007.279,
    y2: 563.391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop4895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop4897"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_26_)"
    },
    id: "rect4900",
    d: "M1977.757 558.546h59.044v4.153h-59.044z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 2007.279,
    y1: 564.602,
    x2: 2007.279,
    y2: 569.451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop4902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop4906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop4908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop4910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop4912"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_28_)"
    },
    id: "rect4915",
    d: "M1977.757 565.294h59.044v4.153h-59.044z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 2007.279,
    y1: 571.697,
    x2: 2007.279,
    y2: 576.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop4917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop4919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop4921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop4923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop4925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop4927"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_30_)"
    },
    id: "rect4930",
    d: "M1977.757 572.043h59.044v4.153h-59.044z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "g4944"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14480",
    d: "M2096.448 541.93s5.635-8.091 9.391-12.57c3.756-4.479 10.258-12.425 10.258-12.425s-17.049-1.951-37.421-.867c-12.943.688-18.974 1.435-21.652 1.888-7.578 5.004-35.346 24.335-35.346 24.335s11.486-.795 25.573-.939c14.088-.144 49.197.578 49.197.578z",
    id: "path4938"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4942"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2091.351 515.741c-3.973 0-8.244.09-12.674.327-12.943.688-18.973 1.436-21.652 1.887-.642.425-1.43.951-2.332 1.56 4.973-.488 14.37-1.199 24.076-1.716a236.81 236.81 0 0 1 12.582-.324c9.417 0 17.208.526 21.343.878a1515.382 1515.382 0 0 1-8.183 9.891c-3.127 3.73-7.447 9.799-8.952 11.934-5.083-.101-29.879-.581-43.986-.581-1.636 0-3.095.009-4.338.02-6.51.066-16.815.465-22.765.731l-2.791 1.942s11.486-.795 25.573-.939c1.28-.014 2.736-.02 4.32-.02 15.861 0 44.876.598 44.876.598s5.635-8.091 9.391-12.57c3.756-4.479 10.258-12.425 10.258-12.425s-10.443-1.193-24.746-1.193z",
    id: "path4940"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "g4970"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1976.022 601.095h51.58s-8.38-16.471-13.292-16.471h-34.387c-4.767.001-3.901 16.471-3.901 16.471z",
    id: "path4946"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14481",
    d: "M2214.658 539.739s3.708.722 4.383 1.204c.674.482 2.215 3.997 2.456 4.479.241.482.289 10.74.289 10.74z",
    id: "path4948"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4954"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14480",
    d: "M2105.261 540.702s12.714-20.155 19.794-23.189c7.08-3.034 20.661-2.528 29.185-1.951 8.524.578 22.828 2.962 27.379 5.201 4.551 2.239 16.399 11.486 17.266 15.604 0 0-2.601 1.228-13.437 2.312-10.836 1.084-40.96 4.262-52.23 4.479-11.27.217-25.935.578-26.729-.072-.794-.65-1.228-2.384-1.228-2.384z",
    id: "path4950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2181.62 520.764c-.127-.064-.263-.124-.405-.188-.766-.338-1.742-.679-2.878-1.014-6.19-1.832-17.095-3.525-24.097-3.999l-.165-.012a215.296 215.296 0 0 0-5.58-.303 144.274 144.274 0 0 0-5.785-.121c-6.554 0-13.324.529-17.656 2.387-7.08 3.034-19.794 23.189-19.794 23.189s.433 1.734 1.228 2.384c.338.275 3.17.37 7.184.37 5.444 0 13.058-.173 19.546-.298 4.433-.087 11.787-.63 19.733-1.323 2.956-.257 5.993-.537 8.995-.818 9.44-.896 18.514-1.838 23.501-2.338.959-.095 1.855-.194 2.687-.292a119.38 119.38 0 0 0 4.392-.589c4.97-.774 6.357-1.43 6.357-1.43-.865-4.119-12.712-13.366-17.263-15.605zm-48.439 20.372-3.283.064c-5.75.116-11.697.234-16.225.234-3.791 0-5.386-.09-6.045-.156a3.642 3.642 0 0 1-.138-.298 178.518 178.518 0 0 1 6.649-9.542c6.779-9.036 10.25-11.437 11.715-12.067 3.444-1.474 9.117-2.222 16.858-2.222 1.971 0 4.066.049 6.325.147a121.328 121.328 0 0 1 2.144 10.403c.754 4.707 1.28 9.328 1.572 12.125-7.898.687-15.183 1.228-19.575 1.312zm52.065-4.471c-1.257.127-2.777.28-4.496.457-5.175.526-12.108 1.228-19.213 1.899-.667-3.141-1.925-8.637-3.323-12.671a199.922 199.922 0 0 0-3.28-8.709c8.631.67 21.629 2.93 25.732 4.909 1.812 2.474 4.094 5.961 5.285 9.244.749 2.06 1.257 3.554 1.598 4.626-.722.081-1.488.164-2.306.245zm6.574-.803c-.543-1.283-1.416-3.051-2.797-5.274-1.046-1.682-2.326-3.427-3.577-5.016a77.15 77.15 0 0 1 4.875 3.829c2.965 2.528 4.704 4.43 5.646 5.707-.957.214-2.303.477-4.147.754z",
    id: "path4952"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2033.815 568.491c-2.408 1.445-3.371 4.142-3.371 4.142s27.74-5.394 30.438-5.779c2.698-.385 11.559 5.972 11.559 5.972s5.394-11.173 16.375-12.907c10.98-1.734 17.916 3.275 23.502 12.714-.193-3.468-.963-7.128-.385-7.898.578-.77 56.637-1.926 59.912-1.926 3.275 0 15.026 2.697 20.805 12.329 0 0 2.89-7.32 8.669-10.788s13.87-1.156 16.76.578c2.89 1.734 3.66 7.706 3.66 7.706s-.193-7.32 0-9.632c.193-2.312 0-5.201 0-5.201s-2.89-6.165-5.201-11.173c-2.311-5.008-4.045-6.165-5.779-6.742-1.734-.578-9.054 3.468-22.924 5.587-13.87 2.119-56.444 6.935-71.085 5.394-14.641-1.541-15.604-1.734-25.429-1.156-9.825.578-15.7.578-15.7.578z",
    id: "path4956"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2116.603 588.526s53.025-1.589 61.116-1.878c8.091-.289 11.125-.867 12.57-4.768 1.445-3.901 1.734-4.768 1.734-4.768l-9.536 1.589s-1.156 3.901-4.623 4.479c-3.468.578-50.28 2.023-55.048 3.034-4.768 1.011-6.213 2.312-6.213 2.312z",
    id: "path4958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2026.591 586.647s25.573-6.213 27.596-6.213c2.023 0 8.813 5.49 10.114 6.646 1.3 1.156 3.178 8.524 2.601 9.247-.577.723-33.953.433-33.953.433z",
    id: "path4960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1967.715 593.004c0 .525.636 2.11 1.395 3.813 2.247 0 4.259-.057 4.259-.057l1.932-10.114s-3.528-2.821-6.018-4.661c-.191 4.464-1.568 9.809-1.568 11.019z",
    id: "path4962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2145.877 549.347 11.684-.73s.618 2.415.393 3.146c-.225.731-.281 1.91-3.707 1.91-3.426 0-7.246-.674-7.583-1.404-.338-.731-.787-2.922-.787-2.922z",
    id: "path4964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2187.488 546.313 11.684-.73s.618 2.415.393 3.146c-.225.73-.281 1.91-3.707 1.91-3.426 0-7.246-.674-7.583-1.404-.338-.731-.787-2.922-.787-2.922z",
    id: "path4966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2057.03 541.352c-15.918 5.346-33.256 10.114-33.256 10.114l30.059-10.129a506.15 506.15 0 0 0-6.581.015c-4.484.046-8.703.158-12.373.289l-33.163 9.825c5.623-3.599 18.821-8.184 22.883-9.354-1.864.106-2.921.179-2.921.179s-9.415 1.252-25.718 4.84c-12.726 2.801-16.677 5.323-17.798 6.295 2.798 2.341 8.873 5.119 21.193 5.119 12.209 0 41.876-2.673 53.627-7.104 11.751-4.431 19.65-2.504 21.383-2.697 1.734-.193 22.082-6.815 22.082-6.815s-23.17-.476-39.417-.577z",
    id: "path4968"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "g4978"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2106.489 543.086s7.296 5.346 8.38 5.346c1.084 0 6.141-3.323 6.141-3.323s3.395.144 4.262.144c.867 0 6.863-1.734 7.441-2.601.578-.867.578-5.346-.289-6.43-.867-1.084-9.391-2.167-11.775-2.023-2.384.144-5.201 2.673-5.996 3.468-.795.795.072 5.418.072 5.418h-8.236z",
    id: "path4972"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14469",
    d: "M2132.424 536.223c-.867-1.084-9.391-2.167-11.775-2.023-2.384.144-5.201 2.673-5.996 3.468-.217.216-.309.718-.33 1.332 1.6.125 7.662.57 9.288.258 1.353-.26 6.38-1.72 9.085-2.516a1.899 1.899 0 0 0-.272-.519z",
    id: "path4974"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14470",
    d: "M2133.096 539.161c-1.561.568-4.271 1.571-5.079 1.974-1.145.572-1.95 2.673-1.156 2.673.52 0 3.789-.865 5.99-1.464.216-.659.307-1.941.245-3.183z",
    id: "path4976"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g4988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4982"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14482",
    d: "M2069.114 549.557c2.21 0 4.397.221 6.505.729-10.884 4.046-14.544 7.128-17.241 14.352-14.352 3.275-24.562 3.853-24.562 3.853s4.046-8.573 11.077-12.233c5.657-2.945 15.12-6.701 24.221-6.701m.001-1.055v1.055-1.055c-10.478 0-20.771 4.77-24.71 6.82-7.263 3.781-11.372 12.355-11.544 12.718a1.054 1.054 0 0 0 1.013 1.503c.103-.006 10.464-.621 24.737-3.878.346-.079.629-.327.753-.659 2.602-6.968 6.019-9.792 16.621-13.732a1.054 1.054 0 0 0-.121-2.013c-2.087-.504-4.358-.759-6.749-.759z",
    id: "path4980"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14483",
    d: "M2033.815 568.491s4.046-8.573 11.077-12.233 19.938-8.573 30.726-5.972c-10.884 4.046-14.544 7.128-17.241 14.352-14.352 3.275-24.562 3.853-24.562 3.853z",
    id: "path4984"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14484",
    d: "M2033.815 568.491s10.21-.578 24.562-3.853c2.697-7.224 6.357-10.306 17.241-14.352-.175-.042-.352-.077-.528-.115-2.756.405-8.191 1.451-12.523 3.824-6.068 3.323-6.357 5.057-9.536 7.513-3.179 2.456-12.426 3.757-13.726 1.878-.518-.748-.554-1.587-.411-2.327-3.28 3.624-5.079 7.432-5.079 7.432z",
    id: "path4986"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "g4996"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14482",
    d: "M1977.756 553.85s.096 8.187-1.541 15.508c0 0-3.034-.867-5.466-2.649 0 0-.319.319-.675.803.018.015.033.033.052.047 2.555 1.872 5.668 2.775 5.8 2.812a1.064 1.064 0 0 0 .829-.107 1.05 1.05 0 0 0 .49-.676c1.645-7.356 1.571-15.411 1.567-15.75a1.04 1.04 0 0 0-.281-.703c-.616.455-.775.715-.775.715z",
    id: "path4990"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14483",
    d: "M1977.756 553.85s.096 8.187-1.541 15.508c0 0-3.034-.867-5.466-2.649 0 0-.409-4.479 1.517-7.946 1.926-3.468 5.49-4.913 5.49-4.913z",
    id: "path4992"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14484",
    d: "M1970.885 563.165c-.278 1.988-.136 3.544-.136 3.544 2.432 1.782 5.466 2.649 5.466 2.649 1.637-7.32 1.541-15.508 1.541-15.508s-.722 7.658-2.89 10.692c-1.486 2.081-3.109.083-3.981-1.377z",
    id: "path4994"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5297"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14481",
    d: "M2374.394 544.801s2.777 1.631 3.042 1.807c.265.176.793 2.865.838 3.438.044.573-.088 5.069-.132 5.29-.044.22-1.19 2.248-1.19 2.248l-2.909-11.197z",
    id: "path5000"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "g5006"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2172.148 539.379s2.469-5.642 2.38-6.171c-.088-.529-2.292-.794-2.645-.794-.353 0-3.968 1.234-4.761 1.587-.793.353-3.262 3.703-3.262 4.232 0 .529.617 1.117.852 1.234.236.118 7.436-.088 7.436-.088z",
    id: "path5002"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "M2167.123 534.001c-.793.353-3.262 3.703-3.262 4.232 0 .016.01.032.01.047 1.012-.042 4.558-.186 4.96-.135l3.659.451c.431-1.005 1.176-2.767 1.637-4.011-.677-.165-2.24-.539-2.549-.539-.397 0-4.952.896-4.952.661s.501-.706.501-.706z",
    id: "path5004"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2312.265 512.732c-13.515-2.601-29.909-2.975-50.719-2.975-21.195 0-38.121 1.324-49.625 3.797 14.473-.931 34.675-2.092 57.031-2.092 15.971-.001 30.842.591 43.313 1.27z",
    id: "path5008"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "g5014"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2277.673 590.372c0 14.385-6.531 26.047-14.593 26.047-2.342 0-4.549-.984-6.51-2.73-4.789-4.271-8.079-13.108-8.079-23.317 0-10.206 3.29-19.043 8.079-23.314 1.961-1.746 4.168-2.729 6.51-2.729 8.062 0 14.593 11.662 14.593 26.043z",
    id: "path5010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2256.571 613.69c1.961 1.746 4.168 2.73 6.51 2.73h-18.306c-8.058 0-14.593-11.662-14.593-26.047 0-14.381 6.535-26.043 14.593-26.043h18.306c-2.342 0-4.549.984-6.51 2.729-4.789 4.271-8.079 13.108-8.079 23.314 0 10.209 3.289 19.046 8.079 23.317z",
    id: "path5012"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "g5020"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2163.773 590.372c0 14.385-6.531 26.047-14.593 26.047-2.342 0-4.549-.984-6.51-2.73-4.789-4.271-8.079-13.108-8.079-23.317 0-10.206 3.29-19.043 8.079-23.314 1.961-1.746 4.168-2.729 6.51-2.729 8.062 0 14.593 11.662 14.593 26.043z",
    id: "path5016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2142.67 613.69c1.961 1.746 4.168 2.73 6.51 2.73h-18.306c-8.058 0-14.593-11.662-14.593-26.047 0-14.381 6.535-26.043 14.593-26.043h18.306c-2.342 0-4.549.984-6.51 2.729-4.789 4.271-8.079 13.108-8.079 23.314 0 10.209 3.29 19.046 8.079 23.317z",
    id: "path5018"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m2371.573 556.542-5.907 36.704s-51.223 11.02-55.955 11.119c-4.733.099-103.002 2.37-109.879 2.37-6.877 0-8.993-2.116-13.034-2.292-4.042-.176-27.168 0-27.168 0-4.934 0-14.988-8.464-14.988-8.464v-39.437z",
    id: "path5022",
    style: {
      fill: "#171717"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5097"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st14471",
    d: "M2365.836 590.372c0 14.385-6.531 26.047-14.593 26.047-2.342 0-4.549-.984-6.51-2.73-4.789-4.271-8.079-13.108-8.079-23.317 0-10.206 3.29-19.043 8.079-23.314 1.961-1.746 4.168-2.729 6.51-2.729 8.062 0 14.593 11.662 14.593 26.043z",
    id: "path5024"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14472",
    cx: 2351.245,
    cy: 590.374,
    rx: 11.565,
    ry: 20.643,
    id: "ellipse5026"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_32_",
    cx: 5179.226,
    cy: 590.374,
    r: 18.522,
    gradientTransform: "matrix(.5602 0 0 1 -550.157 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop5028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop5030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop5032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop5034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop5036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop5038"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_32_)"
    },
    cx: 2351.245,
    cy: 590.374,
    rx: 10.376,
    ry: 18.522,
    id: "ellipse5041"
  }), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2351.245,
    cy: 590.374,
    rx: 4.999,
    ry: 8.923,
    id: "ellipse5043"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g5093"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2351.148 579.426 1.156 10.948-2.532-9.55-4.682-5.359c.66-.874 1.381-1.606 2.15-2.179z",
    id: "path5045"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2354.611 578.616-2.307 11.758.512-11.758-2.973-6.595c.459-.11.927-.168 1.402-.168.475 0 .942.058 1.401.168z",
    id: "path5047"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2357.401 575.465.256 5.359-5.353 9.55 3.977-10.95-1.031-6.138c.769.57 1.49 1.305 2.151 2.179z",
    id: "path5049"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2351.148 579.426 1.156 10.948-2.532-9.55a6.976 6.976 0 0 1 1.376-1.398z",
    id: "path5051"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2354.611 578.616-2.307 11.758.512-11.758c.293-.069.594-.107.898-.107.305 0 .603.038.897.107z",
    id: "path5053"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2357.657 580.824-5.353 9.55 3.977-10.95c.491.37.953.839 1.376 1.4z",
    id: "path5055"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2347.127 588.774 5.177 1.6-5.177 1.603-6.163.9a33.122 33.122 0 0 1 0-5.003z",
    id: "path5057"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2348.364 583.336 3.939 7.038-4.724-4.581-5.909-2.567a24.964 24.964 0 0 1 1.221-3.84z",
    id: "path5059"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2352.304 590.374-3.939 7.038-5.473 3.95a24.96 24.96 0 0 1-1.221-3.837l5.91-2.57z",
    id: "path5061"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2347.581 594.955 4.723-4.581-3.939 7.038a15.75 15.75 0 0 1-.784-2.457z",
    id: "path5063"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2347.127 588.774 5.177 1.6-5.177 1.603a21.6 21.6 0 0 1 0-3.203z",
    id: "path5065"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2348.364 583.336 3.939 7.038-4.724-4.581c.208-.877.471-1.702.785-2.457z",
    id: "path5067"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2349.771 599.924 2.532-9.55-1.156 10.951-3.906 6.141c-.769-.573-1.49-1.308-2.151-2.182z",
    id: "path5069"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2352.818 602.132-.514-11.758 2.309 11.758-1.964 6.595c-.459.11-.927.168-1.402.168-.475 0-.942-.058-1.401-.168z",
    id: "path5071"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "M2357.401 605.283c-.661.871-1.381 1.606-2.15 2.179l1.029-6.141-3.977-10.948 5.353 9.55z",
    id: "path5073"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2356.281 601.321-3.977-10.948 5.353 9.55a6.95 6.95 0 0 1-1.376 1.398z",
    id: "path5075"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2352.818 602.132-.514-11.758 2.309 11.758a3.911 3.911 0 0 1-.898.107c-.306 0-.604-.038-.897-.107z",
    id: "path5077"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2349.771 599.924 2.532-9.55-1.156 10.951a7.13 7.13 0 0 1-1.376-1.401z",
    id: "path5079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2359.064 597.412-6.76-7.038 7.545 4.581.972 2.567a25.184 25.184 0 0 1-1.222 3.84z",
    id: "path5081"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2359.847 585.793-7.543 4.581 6.76-7.038.534-3.95a25.07 25.07 0 0 1 1.222 3.837z",
    id: "path5083"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2360.301 591.974-7.998-1.6 7.998-1.603 1.226-.9a33.122 33.122 0 0 1 0 5.003z",
    id: "path5085"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2359.847 585.793-7.543 4.581 6.76-7.038c.315.755.577 1.58.783 2.457z",
    id: "path5087"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2360.301 591.974-7.998-1.6 7.998-1.603a21.6 21.6 0 0 1 0 3.203z",
    id: "path5089"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2359.064 597.412-6.76-7.038 7.545 4.581c-.208.877-.47 1.702-.785 2.457z",
    id: "path5091"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.733 613.69c1.961 1.746 4.168 2.73 6.51 2.73h-18.306c-8.058 0-14.593-11.662-14.593-26.047 0-14.381 6.535-26.043 14.593-26.043h18.306c-2.342 0-4.549.984-6.51 2.729-4.789 4.271-8.079 13.108-8.079 23.314 0 10.209 3.29 19.046 8.079 23.317z",
    id: "path5095"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5172"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st14471",
    d: "M2262.515 590.372c0 14.385-6.531 26.047-14.593 26.047-2.342 0-4.549-.984-6.51-2.73-4.789-4.271-8.079-13.108-8.079-23.317 0-10.206 3.29-19.043 8.079-23.314 1.961-1.746 4.168-2.729 6.51-2.729 8.062 0 14.593 11.662 14.593 26.043z",
    id: "path5099"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14472",
    cx: 2247.924,
    cy: 590.374,
    rx: 11.565,
    ry: 20.643,
    id: "ellipse5101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 4994.791,
    cy: 590.374,
    r: 18.522,
    gradientTransform: "matrix(.5602 0 0 1 -550.157 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop5105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop5107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop5109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop5111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop5113"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_34_)"
    },
    cx: 2247.924,
    cy: 590.374,
    rx: 10.376,
    ry: 18.522,
    id: "ellipse5116"
  }), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2247.924,
    cy: 590.374,
    rx: 4.999,
    ry: 8.923,
    id: "ellipse5118"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "g5168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2247.827 579.426.45 10.948-1.827-9.55-4.682-5.359c.66-.874 1.381-1.606 2.15-2.179z",
    id: "path5120"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2251.29 578.616-3.012 11.758 1.218-11.758-2.973-6.595c.459-.11.927-.168 1.402-.168.475 0 .942.058 1.401.168z",
    id: "path5122"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2254.081 575.465.256 5.359-6.059 9.55 4.682-10.95-1.031-6.138c.769.57 1.49 1.305 2.152 2.179z",
    id: "path5124"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2247.827 579.426.45 10.948-1.827-9.55a7.033 7.033 0 0 1 1.377-1.398z",
    id: "path5126"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2251.29 578.616-3.012 11.758 1.218-11.758c.293-.069.593-.107.898-.107a3.9 3.9 0 0 1 .896.107z",
    id: "path5128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2254.336 580.824-6.059 9.55 4.682-10.95c.492.37.954.839 1.377 1.4z",
    id: "path5130"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2243.806 588.774 4.471 1.6-4.471 1.603-6.163.9a33.122 33.122 0 0 1 0-5.003z",
    id: "path5132"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2245.043 583.336 3.234 7.038-4.019-4.581-5.909-2.567a24.964 24.964 0 0 1 1.221-3.84z",
    id: "path5134"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2248.278 590.374-3.234 7.038-5.473 3.95a24.96 24.96 0 0 1-1.221-3.837l5.91-2.57z",
    id: "path5136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2244.26 594.955 4.017-4.581-3.234 7.038a15.856 15.856 0 0 1-.783-2.457z",
    id: "path5138"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2243.806 588.774 4.471 1.6-4.471 1.603a21.6 21.6 0 0 1 0-3.203z",
    id: "path5140"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2245.043 583.336 3.234 7.038-4.019-4.581c.208-.877.471-1.702.785-2.457z",
    id: "path5142"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2246.451 599.924 1.827-9.55-.45 10.951-3.907 6.141c-.768-.573-1.49-1.308-2.151-2.182z",
    id: "path5144"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2249.497 602.132-1.219-11.758 3.014 11.758-1.964 6.595c-.459.11-.927.168-1.402.168-.475 0-.942-.058-1.401-.168z",
    id: "path5146"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "M2254.081 605.283c-.661.871-1.381 1.606-2.15 2.179l1.029-6.141-4.682-10.948 6.059 9.55z",
    id: "path5148"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2252.96 601.321-4.682-10.948 6.059 9.55a6.98 6.98 0 0 1-1.377 1.398z",
    id: "path5150"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2249.497 602.132-1.219-11.758 3.014 11.758a3.924 3.924 0 0 1-.898.107c-.305 0-.604-.038-.897-.107z",
    id: "path5152"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2246.451 599.924 1.827-9.55-.45 10.951a7.079 7.079 0 0 1-1.377-1.401z",
    id: "path5154"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2255.743 597.412-7.466-7.038 8.251 4.581.971 2.567a25.184 25.184 0 0 1-1.222 3.84z",
    id: "path5156"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2256.527 585.793-8.249 4.581 7.466-7.038.534-3.95a25.07 25.07 0 0 1 1.222 3.837z",
    id: "path5158"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14472",
    d: "m2256.98 591.974-8.703-1.6 8.703-1.603 1.226-.9a33.122 33.122 0 0 1 0 5.003z",
    id: "path5160"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2256.527 585.793-8.249 4.581 7.466-7.038c.314.755.577 1.58.783 2.457z",
    id: "path5162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2256.98 591.974-8.703-1.6 8.703-1.603a21.6 21.6 0 0 1 0 3.203z",
    id: "path5164"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "m2255.743 597.412-7.466-7.038 8.251 4.581c-.207.877-.47 1.702-.785 2.457z",
    id: "path5166"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2241.413 613.69c1.961 1.746 4.168 2.73 6.51 2.73h-18.306c-8.058 0-14.593-11.662-14.593-26.047 0-14.381 6.535-26.043 14.593-26.043h18.306c-2.342 0-4.549.984-6.51 2.729-4.789 4.271-8.079 13.108-8.079 23.314-.001 10.209 3.29 19.046 8.079 23.317z",
    id: "path5170"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "g5176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2166.333 539.643 8.968-6.478a455.254 455.254 0 0 0-8.968 6.478zm208.149 6.965s1.234-5.113.265-5.907c-.97-.793-16.046-5.378-16.046-5.378s-19.219-14.282-35.441-19.748c-15.433-5.2-34.913-5.819-61.714-5.819-26.801 0-46.786 2.116-57.598 5.995-1.051.377-2.25.906-3.565 1.555 5.152-.652 15.309-1.672 29.778-1.908 21.688-.353 44.258 1.234 44.258 1.234s-5.995 4.937-11.99 12.964c-4.113 5.507-5.819 10.134-5.819 10.134h-90.395s-19.043.942-33.622 5.879c-14.575 4.937-19.981 13.136-21.159 15.016-1.174 1.88-2.701 9.638-2.701 9.638s-1.294 1.178-2 2.5-.176 8.933 0 9.902c.177.97 2.028 6.877 2.381 8.904.353 2.028-.793 3.791-.793 5.554 0 1.763 4.055 3.851 4.055 3.851h116.728s2.821-39.469 21.47-39.469c19.795 0 11.944 39.469 11.944 39.469h74.762s4.339-39.292 19.572-39.292c15.233 0 8.464 31.915 8.464 31.915 5.749-2.352 9.721-5.136 9.962-5.378.617-.617 4.144-9.874 4.232-16.575.086-6.698-5.028-25.036-5.028-25.036zm-28.476-6.876h-80.228c.705-9.522 11.637-21.335 15.34-22.746 0 0 25.92-2.116 42.142 2.821s25.038 12.519 25.038 13.753-1.235 6.172-2.292 6.172z",
    id: "path5174"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "g5188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2230.159 515.398c-14.469.236-24.625 1.255-29.778 1.908-7.12 3.516-17.537 10.544-24.996 15.799l-.085.06-8.968 6.478-.12.088h12.724a97.182 97.182 0 0 1 25.127-20.101c2.067-.061 4.18-.096 6.336-.087 3.926.017 9.367.153 15.429.633a87.53 87.53 0 0 0-10.106 19.422l6.208.015a57.339 57.339 0 0 1 3.879-12.519 57.207 57.207 0 0 1 3.468-6.642c4.168.1 9.693.65 15.928 2.469a62.221 62.221 0 0 1 16.544 7.605c.218-.307.443-.616.677-.929 5.995-8.027 11.99-12.964 11.99-12.964s-22.568-1.587-44.257-1.235z",
    id: "path5178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.205 539.496s7.112-10.697 8.17-11.755c1.058-1.058 22.307-.705 23.835.118 1.528.823 2.939 1.998 3.409 2.821.47.823-2.233 8.816-2.233 8.816h-33.181z",
    id: "path5180"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5186"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14480",
    d: "M2274.417 516.633s-5.995 4.937-11.99 12.964c-4.113 5.507-5.819 10.134-5.819 10.134h-90.395l.12-.088 8.968-6.478.085-.06c7.458-5.254 17.876-12.283 24.996-15.799 5.152-.652 15.309-1.672 29.778-1.908 21.688-.352 44.257 1.235 44.257 1.235z",
    id: "path5182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2236.669 515.349c-2.162 0-4.341.014-6.51.049-14.469.236-24.625 1.255-29.778 1.908-.783.388-1.604.815-2.458 1.28 8.46-.497 22.729-1.27 32.264-1.425 2.077-.035 4.257-.049 6.482-.049 13.729 0 26.992.649 33.484 1.023a88.6 88.6 0 0 0-9.141 10.407c-3.037 4.066-4.803 7.66-5.583 9.426h-86.777l-2.32 1.675-.12.088h90.395s1.707-4.627 5.819-10.135c5.995-8.026 11.99-12.963 11.99-12.963s-18.28-1.287-37.747-1.284z",
    id: "path5184"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st14489",
    d: "M2184.139 595.274s2.821-6.877 4.761-8.111c1.939-1.234 23.628-1.94 24.686-1.587 1.058.353 6.171 4.584 6.171 6.348 0 1.764-7.053 4.056-9.698 4.056-2.645-.001-25.92-.706-25.92-.706z",
    id: "path5190"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2111.432 560.626c-1.174 1.88-2.701 9.638-2.701 9.638s-1.294 1.178-2 2.5-.176 8.933 0 9.902c.177.97 2.028 6.877 2.381 8.904.353 2.028-.793 3.791-.793 5.554 0 1.763 4.055 3.851 4.055 3.851h18.344c-.823-.75-2.346-2.192-2.475-2.705-.177-.705 1.234-1.763 2.116-2.998.882-1.234.705-8.111.705-9.345s-1.234-6.524-.882-7.758c.353-1.234 1.058-2.116 1.587-3.526.529-1.411 2.116-16.046 2.116-16.046s1.234-3.35 8.111-8.464c6.877-5.113 36.94-10.403 36.94-10.403h-12.724s-19.043.942-33.622 5.879c-14.574 4.938-19.98 13.137-21.158 15.017z",
    id: "path5192",
    style: {
      opacity: 0.5,
      fill: "#e6e6e6"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st14489",
    d: "M2118.369 595.274s-2.346-6.877-3.056-8.111c-.71-1.234-7.344-1.94-7.731-1.587a.525.525 0 0 0-.042.046c.606 2.108 1.36 4.73 1.572 5.949.275 1.582-.36 3.002-.654 4.387 2.269-.116 9.911-.684 9.911-.684z",
    id: "path5194"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "m2375.628 556.659-2.469-10.756s-24.686-1.058-59.774.176c-35.089 1.234-100.153 11.285-100.153 11.285s4.056 7.053 8.816 10.227c4.761 3.174 11.99 4.937 11.99 4.937s5.642-13.048 14.988-13.753c9.345-.705 13.577 8.816 13.577 8.816s2.116-3.703 14.635-6.348 37.381-4.937 46.197-4.408c8.816.529 14.459 4.937 14.459 4.937l10.403.705s3.439-4.012 9.786-3.473c7.67.652 9.207 11.349 9.207 11.349s.579-4.702 3.4-8.581c2.822-3.879 4.938-5.113 4.938-5.113z",
    id: "path5196"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2265.403 582.601s46.337-4.783 55.271-5.253c8.934-.47 15.399 7.053 15.399 7.053l-70.383 7.633s.11-2.27-.011-5.191c-.12-2.862-.276-4.242-.276-4.242z",
    id: "path5198"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2188.899 540.202c-8.068 0-21.808.173-29.556.31-4.387.543-16.933 2.301-25.193 5.099a51.934 51.934 0 0 0-8.111 3.518c2.778 1.278 7.436 3.417 18.073 3.417 15.164 0 54.426.235 66.534-3.056 12.108-3.291 36.911-8.464 36.911-8.464s-45.374-.824-58.658-.824z",
    id: "path5200"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st14491",
    d: "M2265.777 539.732s2.704 15.046 3.174 20.219c.47 5.172 0 37.44 0 37.44s57.042-4.981 60.921-5.356c3.879-.375 6.436-3.637 8.111-7.957 1.675-4.32 8.436-22.185 8.891-27.535.455-5.35.692-9.72 0-11.061-.692-1.341-3.425-3.105-5.452-5.75",
    id: "path5202"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st14491",
    d: "M2306.156 539.732s3.469 4.599 3.894 6.487c.426 1.888 1.043 13.35.955 18.199-.088 4.849-1.294 13.177-1.294 13.818s1.223 7.604 1.302 8.883c.079 1.279-.635 6.644-.635 6.644",
    id: "path5204"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5210"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st14492",
    d: "m2184.315 568.766 9.169-10.227s20.806-1.763 25.626-2.234c4.82-.47 9.286-1.293 9.286-1.293s-1.763 10.344-9.874 12.46c-5.831 1.523-34.207 1.294-34.207 1.294z",
    id: "path5206"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2216.847 565.034c4.055-.97 11.549-10.021 11.549-10.021s-4.467.823-9.286 1.293c-4.82.47-25.626 2.233-25.626 2.233l-6.083 8.287c0 .001 25.391-.822 29.446-1.792z",
    id: "path5208",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5216"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st14492",
    d: "m2118.369 568.766-2.739-10.227s-.963-.273-2.218-.633a24.628 24.628 0 0 0-1.981 2.72c-.764 1.223-1.677 4.934-2.222 7.378 2.85.931 9.16.762 9.16.762z",
    id: "path5212"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2111.432 560.626c-.607.972-1.308 3.516-1.844 5.746.895.297 2.139.646 3.05.646 1.587 0 3.703-.191 3.703-.191l-.711-8.287s-.963-.273-2.218-.633a24.636 24.636 0 0 0-1.98 2.719z",
    id: "path5214",
    style: {
      fill: "#feffff"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st14462",
    d: "M2107.907 582.402s7.024 2.351 35.148 2.351c35.353 0 81.58-4.467 81.58-4.467s-26.335 3.62-50.635 5.43c-8.1.603-28.535 1.006-30.945 1.006-3.123 0-14.26-.453-19.308-1.067-10.531-1.278-15.84-3.253-15.84-3.253z",
    id: "path5218"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m2298.794 546.696 9.169-.573s.485 1.896.308 2.469c-.176.573-.22 1.499-2.909 1.499-2.689 0-5.687-.529-5.951-1.102-.264-.573-.617-2.293-.617-2.293z",
    id: "path5220"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m2331.238 545.374 9.169-.573s.485 1.896.309 2.469-.22 1.499-2.909 1.499c-2.689 0-5.687-.529-5.951-1.102-.264-.573-.618-2.293-.618-2.293z",
    id: "path5222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5269"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs5225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_406_",
    d: "M2118.691 559.01h70.209s-9.245 11.285-14.739 13.048c-5.494 1.763-28.003 2.586-30.281 2.586-2.278 0-18.088-1.881-21.036-3.291-2.947-1.411-4.153-12.343-4.153-12.343z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_406_",
    style: {
      overflow: "visible",
      fill: "#141517"
    },
    id: "use5227",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_406_",
    style: {
      overflow: "visible"
    },
    id: "use5229",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 2154.34,
    y1: 560.068,
    x2: 2154.34,
    y2: 563.947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop5232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop5234"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_38_)"
    },
    clipPath: "url(#SVGID_36_)",
    id: "rect5237",
    d: "M2118.134 560.655h72.411v2.821h-72.411z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 2154.34,
    y1: 564.77,
    x2: 2154.34,
    y2: 568.063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop5239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop5241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop5243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop5247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop5249"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_40_)"
    },
    clipPath: "url(#SVGID_36_)",
    id: "rect5252",
    d: "M2118.134 565.24h72.411v2.821h-72.411z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 2154.34,
    y1: 569.589,
    x2: 2154.34,
    y2: 572.648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    },
    id: "stop5254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#030303"
    },
    id: "stop5256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0d0d0d"
    },
    id: "stop5258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#1d1d1d"
    },
    id: "stop5260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#343434"
    },
    id: "stop5262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#424242"
    },
    id: "stop5264"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_42_)"
    },
    clipPath: "url(#SVGID_36_)",
    id: "rect5267",
    d: "M2118.134 569.824h72.411v2.821h-72.411z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "g5285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2285.35 539.026s-11.285-13.283-8.346-15.752c2.939-2.469 35.207-1.293 47.314-.118 6.681.649 14.684 3.945 20.439 6.889-3.986-2.962-11.267-7.126-21.497-10.239-16.222-4.937-42.142-2.821-42.142-2.821-3.703 1.411-14.635 13.224-15.34 22.746h80.228c.147 0 .297-.098.447-.265z",
    id: "path5273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2269.576 539.496s7.112-10.697 8.17-11.755c1.058-1.058 22.307-.705 23.835.118 1.528.823 2.939 1.998 3.409 2.821.47.823-2.233 8.816-2.233 8.816h-33.181z",
    id: "path5275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290.164 539.496c.001-.002 5.986-6.818 7.044-7.876 1.058-1.058 47.917-.705 49.445.118 1.528.823 2.939 1.998 3.409 2.821.47.823-1.107 4.937-1.107 4.937h-58.791z",
    id: "path5277"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14480",
    d: "M2265.777 539.732c.705-9.522 11.637-21.335 15.34-22.746 0 0 25.92-2.116 42.142 2.821s25.038 12.519 25.038 13.753-1.234 6.171-2.292 6.171l-80.228.001z",
    id: "path5279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294.182 517.945c8.265 0 19.947.557 28.667 3.211 8.181 2.49 14.049 5.538 17.531 7.657 3.972 2.417 6.005 4.316 6.493 4.99-.105 1.084-.796 3.641-1.322 4.518h-78.168c.886-4.764 4.099-9.567 6.063-12.15 3.071-4.04 6.41-7.067 8.005-7.796 1.093-.081 6.169-.43 12.731-.43m0-1.41c-7.54 0-13.062.451-13.062.451-3.703 1.411-14.635 13.224-15.34 22.746h80.228c1.058 0 2.292-4.937 2.292-6.171s-8.816-8.816-25.038-13.753c-8.736-2.66-20.282-3.273-29.08-3.273z",
    id: "path5281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.921 526.977a120.43 120.43 0 0 0-4.235-10.285 171.318 171.318 0 0 0-6.27-.154 110.216 110.216 0 0 1 6.579 23.193h7.716c-.932-3.915-2.157-8.2-3.79-12.754z",
    id: "path5283"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2341.824 528.049c.996 1.805 2.438 4.526 2.477 5.217.059 1.058-1.881 4.173-2.998 4.173-.941 0-8.895-11.647-11.373-15.309a87.576 87.576 0 0 0-5.159-1.849l7.979 19.45h13.255c1.058 0 2.292-4.937 2.292-6.171.001-.619-2.217-2.834-6.473-5.511z",
    id: "path5287"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "g5295"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2271.949 527.154s-2.175 5.172-1.117 7.229c.417.811 1.528.94 1.939.94.412 0 1.881-4.349 2.234-4.996.353-.647 2.233-2.116 2.821-2.351.588-.235 13.048.94 13.636 1.117.588.176 2.351 1.352 2.351 1.881 0 .529-.764 5.466-1.058 5.936-.294.47-1.646 1.646-2.586 1.646s-14.165.176-14.929.353c-.764.176-2.292.353-2.292.353h-6.289s.999-4.114 1.705-5.995c.705-1.882 3.585-6.113 3.585-6.113z",
    id: "path5289"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "M2275.123 537.439c1.293-.059 9.757-.529 11.285-.588 1.223-.047 5.079-.508 6.571-.69.346-1.521.835-4.764.835-5.187 0-.529-1.763-1.704-2.351-1.881-.588-.176-13.048-1.352-13.636-1.117-.588.235-2.469 1.705-2.821 2.351-.353.646-1.822 4.996-2.234 4.996l-1.939 2.998s2.997-.823 4.29-.882z",
    id: "path5291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2277.826 527.976c-.588.235-2.469 1.705-2.821 2.351 0 0 13.107.94 14.165.999 1.058.059 3.115-.059 3.174-.47.059-.411-.882-1.763-.882-1.763-.587-.176-13.048-1.352-13.636-1.117z",
    id: "path5293"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5320"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2441.528 552.807c0-1.113 1.749-6.361 2.624-6.957.774-.528 7.521-1.078 9.352-1.193h.507c.398 0 .557.318-.477 4.731-.677 2.892-1.312 2.862-1.908 2.942-.597.079-10.098 1.59-10.098.477z",
    id: "path5299"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st14497",
    d: "M2442.164 552.807c0-1.113 1.749-6.361 2.624-6.957.875-.596 8.826-1.193 9.223-1.193.398 0 .557.318-.477 4.731-.677 2.892-1.312 2.862-1.908 2.942-.597.079-9.462 1.59-9.462.477z",
    id: "path5301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -5362.828,
    y1: 545.691,
    x2: -5362.828,
    y2: 550.146,
    gradientTransform: "matrix(-1 0 0 1 -2883.626 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#595959"
    },
    id: "stop5303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5305"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_44_)"
    },
    d: "M2444.801 550.037h68.802v-4.294h-60.745c-2.173 2.651-8.057 4.294-8.057 4.294z",
    id: "path5308"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st14499",
    d: "M2492.56 555.762s-.186-1.034.186-2.995c.371-1.961 1.405-2.73 1.405-2.73h-4.983s.451 2.703-.079 3.392c-.53.689-2.68 1.116-3.074 1.246-.395.13-.397 1.087-.397 1.087zm-1.133-2.359-.276-.473.505-.421a11.043 11.043 0 0 0-.229.894zm-1.237.327.713-.594.433.743c-.156.901-.207 1.698-.207 1.698h-3.101s1.622-.788 2.162-1.847zm.181-.565c.055-.269.097-.512.126-.726l.243.418zm1.712-1.802s-.102.207-.236.573l-.858.715-.433-.744c.026-.351.017-.544.017-.544z",
    id: "path5310"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st14499",
    d: "M2467.435 555.762s-.186-1.034.186-2.995c.371-1.961 1.405-2.73 1.405-2.73h-4.983s.45 2.703-.08 3.392c-.53.689-2.68 1.116-3.074 1.246-.395.13-.398 1.087-.398 1.087zm-1.133-2.359-.276-.473.505-.421a11.043 11.043 0 0 0-.229.894zm-1.237.327.713-.594.433.743c-.156.901-.207 1.698-.207 1.698h-3.101s1.622-.788 2.162-1.847zm.181-.565c.055-.269.097-.512.126-.726l.243.418zm1.712-1.802s-.102.207-.236.573l-.858.715-.433-.744c.026-.351.017-.544.017-.544z",
    id: "path5312"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 2479.202 550.276)",
    id: "rect5314",
    d: "M2444.801 550.037h68.802v.477h-68.802z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2510.648 552.807c0-1.113 1.749-6.361 2.624-6.957.774-.528 7.521-1.078 9.352-1.193h.507c.397 0 .557.318-.477 4.731-.677 2.892-1.312 2.862-1.908 2.942-.596.079-10.098 1.59-10.098.477z",
    id: "path5316"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st14497",
    d: "M2511.284 552.807c0-1.113 1.749-6.361 2.624-6.957.875-.596 8.826-1.193 9.223-1.193.397 0 .557.318-.477 4.731-.677 2.892-1.312 2.862-1.908 2.942-.596.079-9.462 1.59-9.462.477z",
    id: "path5318"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2302.509 564.32h-18.854c-7.16 0-12.96 11.663-12.96 26.051 0 14.385 5.801 26.048 12.96 26.048h18.854c7.16 0 12.96-11.663 12.96-26.048.001-14.388-5.8-26.051-12.96-26.051z",
    id: "path5322"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2501.12 563.986h-225.949v44.711h225.949l8.88-13.378s1.342-31.333-8.88-31.333z",
    id: "path5324"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5429"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2409.447 564.32h-18.854c-7.16 0-12.96 11.663-12.96 26.051 0 14.385 5.801 26.048 12.96 26.048h18.854c7.16 0 12.961-11.663 12.961-26.048 0-14.388-5.801-26.051-12.961-26.051z",
    id: "path5326"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st148",
    cx: 2409.471,
    cy: 590.37,
    rx: 12.922,
    ry: 26.049,
    id: "ellipse5328"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2409.447,
    cy: 590.37,
    rx: 10.695,
    ry: 22.897,
    id: "ellipse5330"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5427"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M2409.447 567.831c-5.814 0-10.528 10.091-10.528 22.539 0 12.448 4.714 22.539 10.528 22.539 5.815 0 10.529-10.091 10.529-22.539 0-12.448-4.715-22.539-10.529-22.539zm0 41.127c-4.796 0-8.683-8.323-8.683-18.589 0-10.266 3.888-18.589 8.683-18.589 4.796 0 8.684 8.323 8.684 18.589 0 10.266-3.888 18.589-8.684 18.589z",
    id: "path5332"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "g5338"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2412.707 592.267 6.419-6.444-.6-3.954-6.963 2.864a5.12 5.12 0 0 0-.265-.412l-.879-15.061h-1.942l-.88 15.061c-.091.128-.18.266-.265.412l-6.963-2.864-.6 3.954 6.419 6.444c.029.228.063.451.102.669l-3.423 13.29 1.571 2.444 4.846-11.077a1.488 1.488 0 0 0 .328 0l4.847 11.077 1.571-2.444-3.423-13.29c.037-.218.071-.441.1-.669z",
    id: "path5334"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "M2409.447 611.846c-5.532 0-10.032-9.634-10.032-21.477 0-11.842 4.5-21.477 10.032-21.477s10.032 9.634 10.032 21.477-4.5 21.477-10.032 21.477zm0-42.237c-5.347 0-9.698 9.313-9.698 20.76 0 11.447 4.35 20.76 9.698 20.76 5.347 0 9.698-9.313 9.698-20.76 0-11.447-4.351-20.76-9.698-20.76z",
    id: "path5336"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st14500",
    d: "M2409.447 613.266c-5.897 0-10.696-10.271-10.696-22.897 0-12.626 4.798-22.897 10.696-22.897s10.696 10.271 10.696 22.897c0 12.626-4.799 22.897-10.696 22.897zm0-45.077c-5.713 0-10.361 9.95-10.361 22.18s4.648 22.18 10.361 22.18c5.713 0 10.361-9.95 10.361-22.18s-4.648-22.18-10.361-22.18z",
    id: "path5340"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5425"
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "m2414.941 590.575 3.609-4.967c.271-.218.413-.853.324-1.442l-.101-.666c-.088-.578-.369-.912-.645-.767l-3.972 3.449c-.163.086-.337.008-.468-.221a4.049 4.049 0 0 0-.343-.513c-.147-.185-.239-.517-.249-.881l-2.945-14.218c-.017-.612-.254-1.089-.54-1.089h-.328c-.286 0-.523.478-.54 1.089l2.153 14.218c-.01.364-.103.697-.249.881a3.945 3.945 0 0 0-.343.513c-.13.229-.304.307-.468.221l-9.07-3.449c-.275-.146-.557.189-.645.767l-.101.667c-.089.589.053 1.224.324 1.442l8.707 4.967c.167.135.291.444.323.819.034.399.087.783.157 1.149.066.341.047.731-.045 1.043l-6.11 12.097c-.152.516-.091 1.196.14 1.555l.264.411c.233.363.559.27.74-.21l6.681-10.97c.118-.314.303-.476.49-.429a1.255 1.255 0 0 0 .61 0c.187-.046.372.115.49.429l1.583 10.97c.181.48.506.573.739.21l.264-.411c.231-.359.292-1.039.14-1.555l-1.012-12.097a2.313 2.313 0 0 1-.045-1.043c.07-.366.123-.75.157-1.149.033-.376.157-.686.324-.82z",
    id: "path5342"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st14500",
    d: "M2414.787 608.092c-.167 0-.332-.157-.444-.455l-1.481-10.698c-.176-.467-.446-.719-.74-.689a1.316 1.316 0 0 1-.251 0c-.294-.032-.564.222-.74.689l-6.579 10.698c-.191.507-.533.604-.78.222l-.347-.54c-.242-.377-.307-1.097-.147-1.639l6.02-11.791c.145-.49.177-1.095.09-1.66a11 11 0 0 1-.046-.331c-.078-.626-.286-1.129-.555-1.346l-8.52-4.815c-.286-.231-.436-.898-.342-1.52l.133-.875c.092-.606.391-.961.679-.808l8.911 3.365c.256.135.529.02.75-.317l.026-.039c.24-.358.387-.903.403-1.497l-2.164-13.816c.018-.644.268-1.149.57-1.149h.43c.301 0 .552.505.569 1.149l2.934 13.816c.017.594.164 1.14.403 1.497l.026.039c.22.337.494.453.75.317l3.813-3.365c.289-.153.587.202.679.808l.133.875c.094.622-.055 1.29-.341 1.521l-3.422 4.815-.03-.167.03.167c-.269.217-.477.721-.555 1.346a11 11 0 0 1-.046.331c-.087.564-.055 1.169.09 1.66l.922 11.791c.16.542.095 1.263-.147 1.639l-.347.54c-.103.156-.221.232-.337.232zm-2.622-12.202c.324 0 .63.303.826.825l1.481 10.698c.135.358.377.427.551.156l.347-.54c.171-.266.217-.775.104-1.159l-.922-11.791c-.171-.581-.21-1.297-.107-1.963.016-.102.031-.206.043-.311.092-.737.338-1.331.658-1.589l3.422-4.815c.202-.163.308-.635.241-1.075l-.133-.874c-.065-.428-.276-.679-.48-.572l-3.813 3.365c-.303.16-.627.024-.887-.374l-.025-.037c-.281-.42-.454-1.065-.474-1.769l-2.934-13.816c-.012-.455-.189-.812-.402-.812h-.43c-.213 0-.39.357-.403.812l2.164 13.816c-.02.704-.193 1.349-.474 1.77l-.024.037c-.26.398-.584.535-.887.374l-8.911-3.365c-.204-.108-.415.143-.48.571l-.133.875c-.067.44.039.912.241 1.075l8.52 4.815c.32.258.566.852.658 1.589.013.105.028.208.043.311.103.666.064 1.382-.107 1.963l-6.02 11.791c-.113.383-.067.892.104 1.159l.347.54c.174.27.416.202.551-.157l6.579-10.698c.207-.549.536-.856.878-.822.078.008.158.008.236 0 .018-.003.035-.003.052-.003z",
    id: "path5344"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5381"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 2411.996,
    y1: 583.201,
    x2: 2411.996,
    y2: 585.598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5348"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_46_)"
    },
    d: "M2411.349 583.167v2.214c0 .765.29 1.385.647 1.385.357 0 .647-.62.647-1.385v-2.214z",
    id: "path5351"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -74.705,
    y1: 4678.143,
    x2: -74.705,
    y2: 4679.55,
    gradientTransform: "rotate(-72.002 -1647.67 924.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5355"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_48_)"
    },
    d: "m2408.596 589.461.984.684c.34.237.705-.162.815-.889.11-.728-.075-1.509-.416-1.746l-.984-.684z",
    id: "path5358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -4736.298,
    y1: 3575.22,
    x2: -4736.298,
    y2: 3577.445,
    gradientTransform: "rotate(-143.998 -1647.328 924.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5362"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_50_)"
    },
    d: "m2410.542 597.011.608-1.792c.21-.619.146-1.485-.143-1.935-.289-.45-.694-.312-.904.307l-.608 1.792z",
    id: "path5365"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: -5126.815,
    y1: -1196.784,
    x2: -5126.815,
    y2: -1194.56,
    gradientTransform: "rotate(143.998 -1647.5 924.938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5369"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_52_)"
    },
    d: "m2414.497 595.382-.608-1.792c-.21-.619-.615-.756-.904-.307-.289.449-.353 1.316-.143 1.935l.608 1.792z",
    id: "path5372"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: -712.218,
    y1: -3043.661,
    x2: -712.218,
    y2: -3042.254,
    gradientTransform: "rotate(72.002 -1647.794 924.585)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5376"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_54_)"
    },
    d: "m2414.996 586.826-.984.684c-.34.236-.526 1.018-.416 1.746.11.728.476 1.126.815.889l.984-.684z",
    id: "path5379"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2413.338 590.37c0 1.587-.601 2.874-1.343 2.874s-1.343-1.287-1.343-2.874c0-1.587.601-2.874 1.343-2.874s1.343 1.286 1.343 2.874z",
    id: "path5383"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "g5389"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2411.716 593.09v.772c0 .331.125.6.28.6.155 0 .28-.269.28-.6v-.772z",
    id: "path5385"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2412.189 593.862c0 .228-.086.414-.193.414-.107 0-.193-.185-.193-.414 0-.229.086-.414.193-.414.107 0 .193.186.193.414z",
    id: "path5387"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "g5395"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2413.118 591.781.343.239c.147.102.305-.07.353-.385.048-.315-.033-.654-.18-.756l-.343-.239z",
    id: "path5391"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2413.607 591.055c.102.071.157.304.124.521-.033.217-.142.336-.243.266-.101-.071-.157-.304-.124-.521.033-.217.142-.336.243-.266z",
    id: "path5393"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "g5401"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2412.969 588.521.212-.625c.091-.268.063-.643-.062-.838-.125-.195-.301-.135-.392.133l-.212.625z",
    id: "path5397"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2412.799 587.301c.063-.185.184-.226.27-.091.086.134.105.393.043.578-.063.185-.184.226-.27.091-.087-.135-.106-.393-.043-.578z",
    id: "path5399"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "g5407"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2411.476 587.816-.212-.625c-.091-.268-.266-.327-.392-.133-.125.195-.153.57-.062.838l.212.625z",
    id: "path5403"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2410.881 587.787c-.063-.185-.044-.443.043-.578.086-.134.207-.093.27.091.063.184.044.443-.043.578-.087.135-.208.094-.27-.091z",
    id: "path5405"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "g5413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2410.701 590.64-.343.239c-.147.102-.228.441-.18.756.048.315.206.488.353.385l.343-.239z",
    id: "path5409"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2410.504 591.842c-.102.071-.21-.048-.243-.266-.033-.218.022-.45.124-.521.101-.071.21.048.243.266.033.218-.023.451-.124.521z",
    id: "path5411"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2412.313 581.686-2.27-10.438c-.063-.29-.217-.514-.353-.514h-.208c-.136 0-.209.224-.167.514l1.495 10.438c.099.694.462 1.287.788 1.287h.392c.325 0 .474-.594.323-1.287zm-.628.615h-.024c-.231 0-.489-.413-.567-.907l-1.511-9.587c-.035-.225.019-.402.125-.402.105 0 .224.177.27.402l1.947 9.587c.1.494-.01.907-.24.907z",
    id: "path5415"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2408.234 586.044-6.989-2.402c-.194-.067-.392.095-.454.373l-.094.424c-.062.277.033.576.218.687l6.637 3.982c.441.265.945-.076 1.092-.738l.178-.799c.147-.664-.124-1.367-.588-1.527zm.066 1.696-.011.048c-.105.471-.458.719-.775.545l-6.159-3.376c-.145-.079-.221-.31-.173-.525.048-.215.203-.337.352-.279l6.356 2.487c.329.128.515.629.41 1.1z",
    id: "path5417"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2408.764 596.45-4.609 8.932c-.128.248-.173.572-.102.743l.108.261c.071.171.232.133.372-.089l5.011-7.957c.333-.529.473-1.331.305-1.74l-.204-.493c-.168-.409-.574-.251-.881.343zm.668.432.012.03c.12.29.025.856-.208 1.242l-4.531 7.482c-.106.176-.233.21-.288.077-.055-.133-.018-.385.083-.574l4.304-8.031c.222-.413.508-.516.628-.226z",
    id: "path5419"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2413.386 598.34 1.313 7.957c.037.221.151.26.262.089l.17-.261c.112-.171.183-.495.164-.743l-.678-8.932c-.045-.594-.312-.751-.578-.342l-.321.493c-.266.408-.42 1.211-.332 1.739zm.547-1.428.019-.03c.189-.29.379-.187.417.226l.736 8.031a1.04 1.04 0 0 1-.123.574c-.086.133-.174.099-.2-.077l-1.093-7.482c-.056-.386.055-.952.244-1.242z",
    id: "path5421"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2415.569 589.08 2.877-4.199c.08-.117.121-.419.094-.694l-.041-.421c-.027-.275-.112-.431-.197-.358l-3.029 2.632c-.201.175-.319.887-.255 1.545l.077.793c.065.657.283.981.474.702zm-.32-1.295v-.048c-.045-.467.035-.974.177-1.113l2.755-2.696c.065-.063.132.054.153.267.021.213-.012.447-.075.531l-2.669 3.578c-.137.185-.29-.052-.336-.519z",
    id: "path5423"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g5534"
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2495.986 564.32h-18.854c-7.16 0-12.961 11.663-12.961 26.051 0 14.385 5.801 26.048 12.961 26.048h18.854c7.16 0 12.961-11.663 12.961-26.048 0-14.388-5.801-26.051-12.961-26.051z",
    id: "path5431"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st148",
    cx: 2496.01,
    cy: 590.37,
    rx: 12.922,
    ry: 26.049,
    id: "ellipse5433"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2495.986,
    cy: 590.37,
    rx: 10.695,
    ry: 22.897,
    id: "ellipse5435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5532"
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "M2495.986 567.831c-5.815 0-10.528 10.091-10.528 22.539 0 12.448 4.714 22.539 10.528 22.539s10.528-10.091 10.528-22.539c0-12.448-4.713-22.539-10.528-22.539zm0 41.127c-4.796 0-8.683-8.323-8.683-18.589 0-10.266 3.888-18.589 8.683-18.589s8.683 8.323 8.683 18.589c0 10.266-3.888 18.589-8.683 18.589z",
    id: "path5437"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "g5443"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2499.246 592.267 6.419-6.444-.6-3.954-6.963 2.864a5.412 5.412 0 0 0-.265-.412l-.879-15.061h-1.942l-.879 15.061a5.12 5.12 0 0 0-.265.412l-6.963-2.864-.6 3.954 6.419 6.444c.029.228.063.451.101.669l-3.423 13.29 1.571 2.444 4.847-11.077a1.488 1.488 0 0 0 .328 0l4.846 11.077 1.571-2.444-3.423-13.29c.037-.218.071-.441.1-.669z",
    id: "path5439"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "M2495.986 611.846c-5.532 0-10.032-9.634-10.032-21.477 0-11.842 4.5-21.477 10.032-21.477s10.032 9.634 10.032 21.477-4.5 21.477-10.032 21.477zm0-42.237c-5.347 0-9.698 9.313-9.698 20.76 0 11.447 4.35 20.76 9.698 20.76 5.347 0 9.698-9.313 9.698-20.76 0-11.447-4.351-20.76-9.698-20.76z",
    id: "path5441"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st14500",
    d: "M2495.986 613.266c-5.898 0-10.696-10.271-10.696-22.897 0-12.626 4.798-22.897 10.696-22.897 5.897 0 10.696 10.271 10.696 22.897 0 12.626-4.799 22.897-10.696 22.897zm0-45.077c-5.713 0-10.361 9.95-10.361 22.18s4.648 22.18 10.361 22.18c5.713 0 10.361-9.95 10.361-22.18s-4.648-22.18-10.361-22.18z",
    id: "path5445"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5530"
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st684",
    d: "m2501.48 590.575 3.609-4.967c.271-.218.413-.853.324-1.442l-.101-.666c-.088-.578-.369-.912-.645-.767l-3.972 3.449c-.163.086-.337.008-.467-.221a4.052 4.052 0 0 0-.344-.513c-.147-.185-.239-.517-.249-.881l-2.945-14.218c-.017-.612-.254-1.089-.54-1.089h-.328c-.286 0-.523.478-.54 1.089l2.153 14.218c-.01.364-.102.697-.249.881a4.052 4.052 0 0 0-.344.513c-.13.229-.304.307-.467.221l-9.07-3.449c-.275-.146-.557.189-.644.767l-.101.667c-.089.589.053 1.224.324 1.442l8.707 4.967c.167.135.291.444.323.819.034.399.087.783.157 1.149.066.341.047.731-.045 1.043l-6.11 12.097c-.152.516-.091 1.196.14 1.555l.264.411c.233.363.558.27.739-.21l6.681-10.97c.118-.314.303-.476.491-.429a1.255 1.255 0 0 0 .61 0c.187-.046.372.115.491.429l1.583 10.97c.181.48.506.573.74.21l.264-.411c.23-.359.292-1.039.14-1.555l-1.012-12.097a2.313 2.313 0 0 1-.045-1.043c.07-.366.123-.75.157-1.149.03-.376.154-.686.321-.82z",
    id: "path5447"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st14500",
    d: "M2501.325 608.092c-.167 0-.332-.157-.444-.455l-1.481-10.698c-.176-.467-.446-.719-.74-.689a1.316 1.316 0 0 1-.251 0c-.294-.032-.564.222-.74.689l-6.579 10.698c-.191.507-.533.604-.78.222l-.347-.54c-.242-.377-.307-1.097-.147-1.639l6.02-11.791a3.95 3.95 0 0 0 .089-1.66 11 11 0 0 1-.046-.331c-.078-.626-.286-1.129-.555-1.346l-8.52-4.815c-.286-.231-.436-.898-.341-1.52l.133-.875c.092-.606.391-.961.68-.808l8.911 3.365c.256.135.529.02.75-.317l.026-.039c.24-.358.386-.903.403-1.497l-2.164-13.816c.018-.644.268-1.149.569-1.149h.43c.302 0 .552.505.57 1.149l2.934 13.816c.017.594.163 1.14.403 1.497l.026.039c.22.337.494.453.75.317l3.813-3.365c.289-.153.587.202.679.808l.133.875c.094.622-.056 1.29-.342 1.521l-3.422 4.815-.03-.167.03.167c-.269.217-.477.721-.555 1.346-.014.112-.03.222-.046.331a3.952 3.952 0 0 0 .089 1.66l.922 11.791c.16.542.095 1.263-.147 1.639l-.347.54c-.101.156-.219.232-.336.232zm-2.621-12.202c.324 0 .63.303.826.825l1.481 10.698c.135.358.377.427.551.156l.347-.54c.171-.266.217-.775.104-1.159l-.922-11.791c-.171-.581-.21-1.297-.106-1.963.016-.102.03-.206.043-.311.092-.737.338-1.331.658-1.589l3.422-4.815c.202-.163.308-.635.241-1.075l-.133-.874c-.065-.428-.276-.679-.48-.572l-3.813 3.365c-.303.16-.627.024-.887-.374l-.024-.037c-.282-.42-.455-1.065-.474-1.769l-2.934-13.816c-.013-.455-.189-.812-.403-.812h-.43c-.213 0-.39.357-.402.812l2.164 13.816c-.02.704-.192 1.349-.474 1.77l-.024.037c-.26.398-.584.535-.887.374l-8.911-3.365c-.204-.108-.415.143-.48.571l-.133.875c-.067.44.039.912.241 1.075l8.52 4.815c.32.258.566.852.658 1.589.013.105.028.208.043.311.104.666.064 1.382-.106 1.963l-6.02 11.791c-.113.383-.067.892.104 1.159l.347.54c.174.27.416.202.551-.157l6.579-10.698c.207-.549.536-.856.878-.822.078.008.158.008.236 0 .015-.003.032-.003.049-.003z",
    id: "path5449"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5486"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 2498.535,
    y1: 583.201,
    x2: 2498.535,
    y2: 585.598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5453"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_56_)"
    },
    d: "M2497.888 583.167v2.214c0 .765.29 1.385.647 1.385.357 0 .647-.62.647-1.385v-2.214z",
    id: "path5456"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.966,
    y1: 4760.444,
    x2: -47.966,
    y2: 4761.852,
    gradientTransform: "rotate(-72.002 -1647.67 924.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5460"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_58_)"
    },
    d: "m2495.135 589.461.984.684c.34.237.705-.162.815-.889.11-.728-.076-1.509-.416-1.746l-.984-.684z",
    id: "path5463"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: -4806.309,
    y1: 3626.088,
    x2: -4806.309,
    y2: 3628.313,
    gradientTransform: "rotate(-143.998 -1647.328 924.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5467"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_60_)"
    },
    d: "m2497.081 597.011.608-1.792c.21-.619.146-1.485-.143-1.935-.289-.45-.694-.312-.904.307l-.608 1.792z",
    id: "path5470"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: -5196.825,
    y1: -1247.652,
    x2: -5196.825,
    y2: -1245.428,
    gradientTransform: "rotate(143.998 -1647.5 924.938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5474"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_62_)"
    },
    d: "m2501.036 595.382-.608-1.792c-.21-.619-.615-.756-.904-.307-.289.45-.353 1.316-.143 1.935l.608 1.792z",
    id: "path5477"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: -685.479,
    y1: -3125.962,
    x2: -685.479,
    y2: -3124.555,
    gradientTransform: "rotate(72.002 -1647.794 924.585)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5481"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_64_)"
    },
    d: "m2501.535 586.826-.984.684c-.34.236-.526 1.018-.416 1.746.111.728.476 1.126.815.889l.984-.684z",
    id: "path5484"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M2499.877 590.37c0 1.587-.601 2.874-1.343 2.874-.741 0-1.342-1.287-1.342-2.874 0-1.587.601-2.874 1.342-2.874.742 0 1.343 1.286 1.343 2.874z",
    id: "path5488"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "g5494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2498.255 593.09v.772c0 .331.125.6.28.6.155 0 .28-.269.28-.6v-.772z",
    id: "path5490"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2498.728 593.862c0 .228-.087.414-.193.414-.106 0-.193-.185-.193-.414 0-.229.086-.414.193-.414.107 0 .193.186.193.414z",
    id: "path5492"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "g5500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2499.657 591.781.343.239c.147.102.305-.07.353-.385.048-.315-.033-.654-.18-.756l-.343-.239z",
    id: "path5496"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2500.146 591.055c.101.071.157.304.124.521-.033.217-.142.336-.243.266-.102-.071-.157-.304-.124-.521.033-.217.142-.336.243-.266z",
    id: "path5498"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "g5506"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2499.509 588.521.212-.625c.091-.268.063-.643-.062-.838-.125-.195-.3-.135-.391.133l-.212.625z",
    id: "path5502"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2499.337 587.301c.063-.185.184-.226.27-.091.086.134.105.393.043.578-.063.185-.184.226-.27.091-.086-.135-.105-.393-.043-.578z",
    id: "path5504"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "g5512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2498.014 587.816-.212-.625c-.091-.268-.266-.327-.391-.133-.125.195-.153.57-.062.838l.212.625z",
    id: "path5508"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2497.419 587.787c-.063-.185-.043-.443.043-.578.086-.134.207-.093.27.091.062.185.043.443-.043.578-.086.135-.207.094-.27-.091z",
    id: "path5510"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "g5518"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2497.24 590.64-.343.239c-.147.102-.228.441-.18.756.048.315.206.488.353.385l.343-.239z",
    id: "path5514"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14506",
    d: "M2497.043 591.842c-.101.071-.21-.048-.243-.266-.033-.218.023-.45.124-.521.102-.071.21.048.243.266.033.218-.023.451-.124.521z",
    id: "path5516"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2498.852 581.686-2.27-10.438c-.063-.29-.217-.514-.353-.514h-.208c-.136 0-.209.224-.167.514l1.495 10.438c.099.694.462 1.287.787 1.287h.392c.326 0 .475-.594.324-1.287zm-.628.615h-.023c-.231 0-.49-.413-.567-.907l-1.511-9.587c-.036-.225.019-.402.125-.402.105 0 .224.177.27.402l1.947 9.587c.099.494-.01.907-.241.907z",
    id: "path5520"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2494.773 586.044-6.989-2.402c-.194-.067-.392.095-.453.373l-.094.424c-.062.277.033.576.218.687l6.637 3.982c.441.265.944-.076 1.092-.738l.178-.799c.146-.664-.125-1.367-.589-1.527zm.066 1.696-.011.048c-.105.471-.458.719-.775.545l-6.159-3.376c-.145-.079-.221-.31-.173-.525.048-.215.203-.337.352-.279l6.357 2.487c.327.128.514.629.409 1.1z",
    id: "path5522"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2495.303 596.45-4.609 8.932c-.128.248-.172.572-.102.743l.108.261c.071.171.233.133.372-.089l5.011-7.957c.333-.529.474-1.331.305-1.74l-.203-.493c-.169-.409-.575-.251-.882.343zm.668.432.012.03c.12.29.025.856-.208 1.242l-4.531 7.482c-.106.176-.233.21-.288.077-.055-.133-.018-.385.083-.574l4.305-8.031c.221-.413.507-.516.627-.226z",
    id: "path5524"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2499.925 598.34 1.313 7.957c.037.221.151.26.262.089l.17-.261c.112-.171.183-.495.164-.743l-.678-8.932c-.045-.594-.312-.751-.578-.342l-.321.493c-.267.408-.42 1.211-.332 1.739zm.547-1.428.019-.03c.189-.29.379-.187.417.226l.736 8.031a1.04 1.04 0 0 1-.123.574c-.086.133-.174.099-.2-.077l-1.093-7.482c-.057-.386.055-.952.244-1.242z",
    id: "path5526"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st14485",
    d: "m2502.108 589.08 2.877-4.199c.08-.117.121-.419.094-.694l-.041-.421c-.027-.275-.113-.431-.197-.358l-3.029 2.632c-.201.175-.319.887-.255 1.545l.077.793c.064.657.283.981.474.702zm-.32-1.295-.01-.048c-.045-.467.035-.974.177-1.113l2.755-2.696c.065-.063.132.054.153.267.021.213-.012.447-.075.531l-2.669 3.578c-.137.185-.29-.052-.336-.519z",
    id: "path5528"
  }))))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M2440.553 559.372c-8.546 1.77-17.606 2.958-17.606 2.958l-15.547-7.07s5.766-11.81 11.635-15.062c5.869-3.251 18.784-2.665 28.314 1.417 4.427 3.871 10.708 12.622 10.708 12.622s-8.958 3.365-17.504 5.135z",
    id: "path5536"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st14512",
    d: "M2440.553 559.372c-8.546 1.77-17.606 2.958-17.606 2.958l-15.547-7.07s5.766-11.81 11.635-15.062c5.869-3.251 18.784-2.665 28.314 1.417 4.427 3.871 10.708 12.622 10.708 12.622s-8.958 3.365-17.504 5.135z",
    id: "path5538"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "g5542"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2456.931 554.647c.717-.256 1.124-.41 1.124-.41s-.69-1.004-1.787-2.46c-1.781-2.362-6.181-7.766-8.919-10.161-9.936-4.198-22.445-4.669-28.314-1.417-5.869 3.251-11.635 15.062-11.635 15.062l.502.228.908.412c.899-1.693 3.277-6.02 5.863-9.399.991 1.439 2.733 4.093 4.052 6.835 1.262 2.623 2.352 6.208 2.967 8.422l1.254.57s.392-.052 1.082-.148c-.484-1.618-1.448-4.578-2.833-7.596-1.637-3.568-4.247-7.979-5.251-9.638a16.41 16.41 0 0 1 1.646-1.642c4.222-3.568 12.742-4.163 19.28-3.236s9.813 2.322 10.502 2.728c.569.336 8.191 10 9.559 11.85z",
    id: "path5540"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5557"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st14513",
    d: "M2309.116 562.989s-.502-.077-.811-.309c-.309-.232.316-5.865.355-6.251.039-.386-2.587-5.405-5.367-5.405h-10.656c-1.197 0-4.788 2.587-4.788 3.436 0 .849 1.004 3.359 3.552 4.208 2.548.849 9.768 1.699 10.734 1.699.965 0 2.935-.435 2.935-.435s-.664 1.791-.664 2.517c0 .725-.151 1.274 1.428 1.274s3.282-.734 3.282-.734z",
    id: "path5544"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st14514",
    d: "M2307.077 555.696s-9.614-1.351-11.081-1.544c-1.467-.193-2.124-1.042-2.703-1.66l-1.12-1.197s-1.274.502-2.201 1.158c-.927.656-1.428 1.274-1.428 1.274s1.776-1.429 3.127-1.429c1.351 0 1.738 2.239 2.625 2.51.887.271 12.781.888 12.781.888z",
    id: "path5546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: -4840.947,
    y1: 552.723,
    x2: -4839.547,
    y2: 564.053,
    gradientTransform: "matrix(-1 0 0 1 -2542.128 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    style: {
      stopColor: "#c7c7c7"
    },
    id: "stop5550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "gray"
    },
    id: "stop5552"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_66_)"
    },
    d: "M2298.621 555.58c2.664.193 9.769.695 9.769.695s-.532 3.852-.629 5.019c-.079.95.079 1.583.508 2.001-.64.201-1.555.428-2.433.428-1.58 0-1.428-.549-1.428-1.274s.664-2.516.664-2.516-1.969.435-2.935.435c-.965 0-8.185-.849-10.734-1.699-2.549-.85-3.552-3.359-3.552-4.208 0-.001 8.106.926 10.77 1.119z",
    id: "path5555"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5563",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2324.414 552.687s6.65 1.33 9.193 1.599l-2.09-7.586c-3.578 1.648-7.103 5.987-7.103 5.987zm29.755-12.047c-6.587.499-17.43 4.19-21.559 5.635l2.478 8.054c5.043-.039 30.612-.304 30.612-.304s4.016-7.722 5.869-11.737c-2.985-1.236-10.604-2.163-17.4-1.648z",
    id: "path5559",
    style: {
      fill: "#005952"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m2334.975 554.485-2.555-8.306.14-.049c9.56-3.346 17.028-5.297 21.598-5.644 7.029-.533 14.541.446 17.471 1.659l.148.061-.067.146c-1.834 3.973-5.832 11.667-5.872 11.744l-.043.082-.093.001c-.256.003-25.627.266-30.613.304zm-2.173-8.113 2.4 7.802c5.085-.04 28.722-.285 30.404-.302.431-.831 4-7.722 5.755-11.501-3.015-1.175-10.529-2.08-17.18-1.576-4.521.342-11.911 2.27-21.379 5.577zm1.014 8.092-.225-.024c-2.521-.267-9.141-1.588-9.207-1.602l-.251-.05.161-.199c.036-.044 3.589-4.386 7.159-6.029l.165-.076zm-9.116-1.878c1.205.238 6.35 1.243 8.698 1.521l-1.981-7.189c-3.015 1.46-5.993 4.818-6.717 5.668z",
    id: "path5561"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M2371.981 536.007c-12.046 0-19.957.626-26.873 1.133-6.965 1.935-8.355 2.712-16.268 5.766a242.625 242.625 0 0 0-26.1 11.892 89.394 89.394 0 0 1 15.907 3.089l35.676-.309a228.725 228.725 0 0 1 46.641-3.243s3.321-3.784 6.795-7.645c3.475-3.861 7.954-7.876 7.954-7.876-12.123-2.189-31.685-2.807-43.732-2.807zm-47.567 16.68s3.525-4.339 7.103-5.987l2.09 7.586c-2.544-.27-9.193-1.599-9.193-1.599zm41.287 1.338s-25.569.265-30.612.304l-2.478-8.054c4.129-1.445 14.972-5.136 21.559-5.635 6.795-.515 14.414.412 17.4 1.647-1.853 4.016-5.869 11.738-5.869 11.738z",
    id: "path5565"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st14513",
    d: "M2511.236 587.516s0-3.735-.978-12.281c-.978-8.546-5.817-15.65-5.817-15.65s-2.355-1.081-7.182-2.548c-4.826-1.467-8.687-2.317-8.687-2.317-21.004-11.662-46.113-18.07-53.99-19.228-7.876-1.158-66.822-4.633-88.443.618-21.622 5.251-46.178 19.151-46.178 19.151s-8.34-1.544-20.077 4.633c-11.738 6.178-19.46 22.085-19.46 22.085l1.081 2.162.618 15.599-1.853 11.583h12.355l9.884-10.193h42.008l2.471 10.193h66.41s-2.008-46.271 18.533-46.271c17.915 0 7.876 46.271 7.876 46.271h65.949s.306-41.398 12.97-44.438c12.664-3.04 11.274 28.435 11.274 28.435s2.008-4.022 2.162-5.016c.155-.995-.926-2.788-.926-2.788zm-110.271-33.182a228.725 228.725 0 0 0-46.641 3.243l-35.676.309a89.482 89.482 0 0 0-15.907-3.089 242.714 242.714 0 0 1 26.1-11.892c7.913-3.054 9.302-3.83 16.268-5.766 6.916-.507 14.826-1.133 26.873-1.133 12.046 0 31.609.618 43.733 2.806 0 0-4.479 4.015-7.954 7.876-3.476 3.862-6.796 7.646-6.796 7.646zm39.588 5.038c-8.546 1.77-17.606 2.958-17.606 2.958l-15.547-7.07s5.766-11.81 11.635-15.062c5.869-3.251 18.784-2.665 28.314 1.417 4.427 3.871 10.708 12.622 10.708 12.622s-8.958 3.365-17.504 5.135z",
    id: "path5569"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 2424.337,
    y1: 578.393,
    x2: 2483.358,
    y2: 578.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "gray"
    },
    id: "stop5573"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_68_)"
    },
    d: "M2425.109 595.724s33.977-1.963 38.765-2.265c4.788-.302 11.737-4.767 13.127-5.711 1.39-.944 6.508-19.877 6.353-20.356-.154-.479-13.509-6.287-15.517-6.33-2.008-.043-43.501 10.723-43.501 10.723s.566 3.326.669 9.72c.103 6.349.104 14.219.104 14.219z",
    id: "path5576"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 2452.239,
    y1: 604.791,
    x2: 2452.239,
    y2: 596.256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5580"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_70_)"
    },
    d: "m2473.912 595.312-47.259 2.574s2.497 7.001 4.35 7.001h46.821z",
    id: "path5583"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st14514",
    d: "m2357.867 582.581-24.25 3.223s16.223-7.554 17.459-8.325c1.236-.771 11.583.01 11.583.01s16.845-12.65 28.276-16.347c11.431-3.697 20.698-4.152 27.488 2.649-6.483-4.639-11.116-4.488-16.526.913-14.828 2.613-30.28 11.558-30.28 11.558s-7.26 1.384-8.496 2.001c-1.235.615-5.254 4.318-5.254 4.318z",
    id: "path5585"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st14514",
    d: "M2424.413 563.467s.114 1.739.107 3.291c-.01 1.552-.183 3.89-.183 3.89s21.477-5.879 36.925-9.589c15.448-3.71 29.636-4.462 29.636-4.462s-12.489-.947-24.929.528c-12.44 1.474-41.556 6.342-41.556 6.342z",
    id: "path5587"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M2424.955 595.888v-.163c0-.06-.024-6.058 0-12.009.039-12.117.199-12.234.316-12.32.261-.19 1.102-1.11 1.45-1.5.09-1.734.201-4.527.122-4.803-.078-.239-1.541-1.608-2.911-2.794a.155.155 0 0 1 .202-.234c.675.584 2.887 2.523 3.007 2.943.119.421-.089 4.495-.114 4.958v.054l-.036.041c-.046.052-1.117 1.253-1.502 1.559-.225.868-.254 14.672-.219 23.94l34.349-2.003c-1.779-.156-3.589-.486-3.589-1.185 0-.49.238-1.392.711-3.187.622-2.356 1.661-6.298 3.076-12.798 1.799-8.266 2.26-11.493 2.457-12.871.075-.524.112-.787.173-.968.199-.599 2.138-2.086 2.618-2.448-.2-.73-.76-2.358-1.355-2.553-.633-.208-7.908-.813-11.666-1.104a.155.155 0 0 1-.142-.166.158.158 0 0 1 .166-.142c.445.035 10.913.847 11.739 1.118.895.294 1.516 2.607 1.584 2.869l.026.1-.083.062c-.929.692-2.455 1.945-2.594 2.361-.052.154-.088.408-.16.914-.197 1.381-.659 4.616-2.461 12.893-1.417 6.507-2.457 10.453-3.079 12.811-.452 1.714-.701 2.658-.701 3.109 0 .586 3.244.982 6.249 1.012l.01.309z",
    id: "path5589"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5604"
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M2449.112 542.052s4.852.189 5.135.206c.318.019 2.817.383 3.398.57 5.985 1.93 21.352 8.958 21.352 8.958l-15.018-.117s-.169-1.802-.342-2.111c-.173-.309-9.736-6.229-10.08-6.384-.344-.155-4.445-1.122-4.445-1.122z",
    id: "path5591"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 2469.447,
    y1: 553.454,
    x2: 2469.643,
    y2: 551.347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "gray"
    },
    id: "stop5595"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_72_)"
    },
    id: "polygon5598",
    d: "m2463.979 551.668 15.017.118-18.958 1.834z"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M2449.112 542.052s4.278 1.457 4.736 1.508c.458.051 7.004 6.049 7.063 6.461.059.412-.872 3.599-.872 3.599h-1.416s-1.647-2.425-3.844-4.994c-2.198-2.569-5.667-6.574-5.667-6.574z",
    id: "path5600"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M2454.72 543.097c-.344-.154-5.608-1.045-5.608-1.045s4.278 1.457 4.736 1.508c.458.051 7.004 6.049 7.063 6.461.059.412-.872 3.599-.872 3.599l3.94-1.951s-.169-1.802-.342-2.111c-.173-.309-8.573-6.307-8.917-6.461z",
    id: "path5602"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st14462",
    d: "m2328.687 597.268 41.853 4.788-11.738-15.444 37.375-10.656s-27.799 5.714-37.529 7.568c-9.73 1.853-34.286 4.633-34.286 4.633l1.236-1.544s-29.961 1.93-33.359 1.93c-3.398 0-19.537-3.475-19.537-3.475l1.351 2.085-5.984-.965-7.645-4.208 1.081 2.162.618 15.599-1.853 11.583h7.259l6.177-7.259 6.178-7.104 2.625 4.17h42.008l-.155-2.78z",
    id: "path5606"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "polygon5608",
    d: "M2335.019 605.917h27.799l7.722-3.861-12.664-15.29-28.263 4.788-.617 5.56z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st14520",
    id: "polygon5610",
    d: "m2334.555 596.96 4.788 6.332 23.321-.309-7.722-14.054-19.923 2.934z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "polygon5612",
    d: "m2261.505 584.141.618 15.598 3.398 2.78 8.185 1.545 6.178-7.104-4.17-6.95z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st14520",
    id: "polygon5614",
    d: "m2276.795 596.805-2.935 6.023-7.722-.926-2.934-2.78-.464-12.664 11.893 4.478z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st14514",
    d: "m2335.019 605.917-6.023-8.803-4.633 1.235.155 2.78 2.471 10.193h27.51l8.321-5.405z",
    id: "path5616"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st14512",
    d: "M2302.741 554.797a242.714 242.714 0 0 1 26.1-11.892c7.913-3.054 9.302-3.83 16.268-5.766 6.916-.507 14.826-1.133 26.873-1.133 12.046 0 31.609.618 43.733 2.806 0 0-4.479 4.015-7.954 7.876-3.475 3.861-6.795 7.645-6.795 7.645a228.725 228.725 0 0 0-46.641 3.243l-35.676.309a89.482 89.482 0 0 0-15.908-3.088z",
    id: "path5618"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5683"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    id: "defs5621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_426_",
    d: "m2481.634 568.131-13.591-5.8s-7.413 24.941-7.722 26.455c-.309 1.514 3.964 3.478 5.045 3.585 1.081.106 10.619-4.969 11.206-5.604.669-.725 5.062-18.636 5.062-18.636z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_426_",
    style: {
      overflow: "visible",
      fill: "#1a1a1a"
    },
    id: "use5623",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_426_",
    style: {
      overflow: "visible"
    },
    id: "use5625",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_74_)",
    id: "g5637"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 2473.719,
    y1: 569.535,
    x2: 2473.719,
    y2: 568.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5630"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_76_)"
    },
    id: "polygon5633",
    d: "m2483.475 569.513-19.511-.037v-1.203h19.511z"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "rect5635",
    d: "M2463.964 569.476h19.511v.382h-19.511z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_74_)",
    id: "g5648"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 2472.413,
    y1: 574.231,
    x2: 2472.413,
    y2: 572.924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5641"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_78_)"
    },
    id: "polygon5644",
    d: "m2482.168 574.209-19.511-.037v-1.203h19.511z"
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "rect5646",
    d: "M2462.657 574.172h19.511v.382h-19.511z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_74_)",
    id: "g5659"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 2471.106,
    y1: 578.927,
    x2: 2471.106,
    y2: 577.62
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5652"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5655",
    style: {
      fill: "url(#SVGID_79_)"
    },
    d: "m2480.862 578.905-19.511-.037v-1.203h19.511z"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "rect5657",
    d: "M2461.351 578.868h19.511v.382h-19.511z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_74_)",
    id: "g5670"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 2469.8,
    y1: 583.623,
    x2: 2469.8,
    y2: 582.316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5663"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5666",
    style: {
      fill: "url(#SVGID_80_)"
    },
    d: "m2479.556 583.601-19.511-.037v-1.203h19.511z"
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "rect5668",
    d: "M2460.045 583.564h19.511v.382h-19.511z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_74_)",
    id: "g5681"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 2469.26,
    y1: 588.319,
    x2: 2469.26,
    y2: 587.012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5674"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5677",
    style: {
      fill: "url(#SVGID_81_)"
    },
    d: "m2479.015 588.297-19.511-.037v-1.203h19.511z"
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "rect5679",
    d: "M2459.504 588.26h19.511v.382h-19.511z"
  })))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m2481.634 568.131-7.215-3.079c1.326 1.284 3.71 3.642 3.766 4.032.077.54-4.093 16.068-4.633 16.721-.54.653-8.185 6.566-8.185 6.566 1.081.106 10.619-4.969 11.206-5.604.668-.725 5.061-18.636 5.061-18.636z",
    id: "path5685"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "m2307.219 575.595-.046-.007c-2.198-.692-5.562-1.727-5.825-1.743-.15.01-1.45.416-2.597.774-1.946.607-3.144.976-3.372.976h-14.137l-5.383-2.277a.154.154 0 1 1 .12-.284l5.325 2.253h14.074c.202-.001 1.981-.557 3.28-.962 1.756-.548 2.541-.788 2.692-.788.314 0 4.91 1.441 5.892 1.75h25.716l11.464-1.183a.155.155 0 0 1 .169.138.153.153 0 0 1-.138.169l-11.48 1.184z",
    id: "path5689"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M2276.794 569.373a.15.15 0 0 1-.083-.025.153.153 0 0 1-.046-.213c.053-.082 5.321-8.226 9.626-10.782 4.299-2.551 8.376-3.279 8.417-3.286a.155.155 0 0 1 .053.305c-.04.007-4.064.727-8.312 3.248-4.243 2.518-9.472 10.602-9.524 10.683a.158.158 0 0 1-.131.07z",
    id: "path5691"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M2354.497 569.731a.154.154 0 0 1-.073-.29c.094-.051 9.541-5.103 20.772-9.28 11.234-4.178 21.621-6.057 21.725-6.076a.154.154 0 1 1 .054.304c-.104.018-10.464 1.893-21.671 6.061-11.212 4.169-20.64 9.212-20.734 9.262a.147.147 0 0 1-.073.019z",
    id: "path5693"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5709"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 2288.378,
    y1: 573.141,
    x2: 2308.996,
    y2: 573.141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "gray"
    },
    id: "stop5695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5697"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#SVGID_83_)"
    },
    d: "M2301.351 573.69c9.046-7.455 26.133-13.819 32.19-15.933l-14.893.129a88.033 88.033 0 0 0-26.152 10.656 87.964 87.964 0 0 0-19.794 16.525c2.012.452 4.853 1.061 8.275 1.695 3.699.685 7.636 1.414 11.107 1.763 1.487-3.354 5.432-11.675 9.267-14.835z",
    id: "path5700"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 2322.49,
    y1: 580.727,
    x2: 2324.492,
    y2: 559.211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "gray"
    },
    id: "stop5702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop5704"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_85_)"
    },
    d: "M2333.541 557.757c-6.058 2.114-23.144 8.479-32.19 15.933-3.834 3.16-7.78 11.481-9.267 14.835l.155.017c5.547.543 7.832-.348 17.954-.965 7.915-.483 15.406-.965 15.406-.965a155.268 155.268 0 0 1 28.726-29.034l-20.784.179z",
    id: "path5707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 2374.016,
    y1: 597.886,
    x2: 2374.016,
    y2: 611.482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "gray"
    },
    id: "stop5713"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_87_)"
    },
    d: "m2393.535 601.031-22.995 1.025-7.722 3.861-8.321 5.405h38.9s-.186-4.308.138-10.291z",
    id: "path5716"
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st14514",
    d: "M2501.12 563.986s-6.847-2.188-12.664 10.425c-5.817 12.613-5.174 30.27-5.174 30.27s-4.839-18.765.618-31.969c5.456-13.204 17.22-8.726 17.22-8.726z",
    id: "path5718"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st14462",
    d: "M2292.088 588.516v.01c-3.471-.35-7.408-1.078-11.107-1.763a223.695 223.695 0 0 1-8.275-1.695l9.807 16.062h15.29l-5.56-12.587z",
    id: "path5720"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 2452.874,
    y1: 605.305,
    x2: 2452.874,
    y2: 612.009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "gray"
    },
    id: "stop5724"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_89_)"
    },
    d: "M2420.806 605.917c-.543 3.303-.999 5.405-.999 5.405h65.949s.016-2.11.185-5.405z",
    id: "path5727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5742"
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st14513",
    d: "M2425.412 562.989s.502-.077.811-.309c.309-.232-.316-5.865-.354-6.251-.039-.386 2.587-5.405 5.367-5.405h10.656c1.197 0 4.788 2.587 4.788 3.436 0 .849-1.004 3.359-3.552 4.208-2.548.849-9.768 1.699-10.734 1.699-.966 0-2.935-.435-2.935-.435s.664 1.791.664 2.517c0 .725.151 1.274-1.428 1.274s-3.283-.734-3.283-.734z",
    id: "path5729"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st14514",
    d: "M2427.452 555.696s9.614-1.351 11.081-1.544c1.467-.193 2.124-1.042 2.703-1.66l1.12-1.197s1.274.502 2.201 1.158c.927.656 1.429 1.274 1.429 1.274s-1.776-1.429-3.127-1.429c-1.351 0-1.738 2.239-2.625 2.51-.887.271-12.782.888-12.782.888z",
    id: "path5731"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 2435.709,
    y1: 552.723,
    x2: 2437.11,
    y2: 564.053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    style: {
      stopColor: "#c7c7c7"
    },
    id: "stop5735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "gray"
    },
    id: "stop5737"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_91_)"
    },
    d: "M2435.907 555.58c-2.664.193-9.768.695-9.768.695s.532 3.852.629 5.019c.079.95-.079 1.583-.508 2.001.64.201 1.555.428 2.433.428 1.58 0 1.428-.549 1.428-1.274s-.664-2.516-.664-2.516 1.969.435 2.935.435 8.185-.849 10.734-1.699c2.549-.85 3.552-3.359 3.552-4.208 0-.001-8.106.926-10.771 1.119z",
    id: "path5740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5773"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", {
    id: "defs5745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_438_",
    d: "M2344.44 574.257s2.934-2.471 4.788-3.398c1.853-.927 29.498-5.869 29.498-5.869l-19.073 14.324-9.73.039z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 2361.582,
    y1: 579.662,
    x2: 2361.582,
    y2: 564.748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    style: {
      stopColor: "#fdfefe"
    },
    id: "stop5749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    style: {
      stopColor: "#f5f9f9"
    },
    id: "stop5751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#e8f0f2"
    },
    id: "stop5753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    style: {
      stopColor: "#d5e4e8"
    },
    id: "stop5755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    style: {
      stopColor: "#bdd5da"
    },
    id: "stop5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a5c6cd"
    },
    id: "stop5759"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_438_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_93_)"
    },
    id: "use5762",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_95_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_438_",
    style: {
      overflow: "visible"
    },
    id: "use5764",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_95_)",
    id: "g5771"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2344.05 572.929c1.403-.68.933.287 2.508.865.973.357 2.165.297 3.109.455.99.165 2.245.624 3.717.67 1.158.036 2.365-.847 3.698-.98 1.202-.12 2.514.349 3.772.027.908-.232 1.979-1.169 3.427-1.784 1.1-.467 2.153-1.281 3.375-1.856 1.166-.549 2.755-.269 3.885-.829 1.247-.619 2.471-1.14 3.492-1.665 2.031-1.044 4.743-3.299 3.464-1.851-1.32 1.493-1.094 1.823-2.607 3.12-1.514 1.297-.849.925-2.363 2.222-1.513 1.297-2.125 1.73-3.638 3.027-1.514 1.298-1.547 1.259-3.061 2.557s-1.626 2.583-3.619 2.507c-2.602-.1-1.611-4.214-3.876-4.523-1.142-.156-2.949.794-4.65.808-1.672.014-3.455-.634-4.629-.429-.953.166-2.446.586-3.385 1.236-1.393.965-1.443 2.373-1.628 2.127-.309-.412-2.87-1.608-3.47-4.144-.258-1.083 1.385-1.03 2.479-1.56z",
    id: "path5767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2346.859 578.53s2.162-1.441 3.295-1.647c1.133-.206 3.089 1.133 4.016 1.133s2.883.515 3.707.721c.824.206 2.162-1.03 2.574-.618.412.412 1.339 1.647 1.339 1.647l-13.282.206z",
    id: "path5769"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g5808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5806"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", {
    id: "defs5778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_441_",
    d: "m2277.361 570.293-3.334-6.326c-5.019 4.346-8.905 9.945-11.215 13.739h4.15l8.958-4.53z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 2267.652,
    y1: 578.213,
    x2: 2276.475,
    y2: 563.936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    },
    id: "stop5780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    style: {
      stopColor: "#fdfefe"
    },
    id: "stop5782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    style: {
      stopColor: "#f5f9f9"
    },
    id: "stop5784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#e8f0f2"
    },
    id: "stop5786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    style: {
      stopColor: "#d5e4e8"
    },
    id: "stop5788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    style: {
      stopColor: "#bdd5da"
    },
    id: "stop5790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a5c6cd"
    },
    id: "stop5792"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_441_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_97_)"
    },
    id: "use5795",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_99_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_441_",
    style: {
      overflow: "visible"
    },
    id: "use5797",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_99_)",
    id: "g5804"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2277.453 569.533c-.036-.837-.793.383-2.207 1.141-.86.461-1.329.356-1.914.54-.598.188-1.624.742-2.228.746-.454.004.113-1.08-.191-1.248-.26-.144-1.156.346-1.189-.015-.023-.248.594-1.168.766-1.72.123-.393.546-1.053.704-1.478.143-.382-.471-.118-.304-.492.175-.391.274-.695.417-.997.266-.561 1.117-1.716.486-.97-.708.837-.984 1.054-1.587 1.843-.661.864-.514.614-1.221 1.535-.778 1.014-1.033 1.376-1.925 2.542-.996 1.301-.948 1.263-2.063 2.72-1.261 1.648-2.95 3.335-2.455 3.477.698.201 5.657-5.148 6.642-5.425.517-.145 0 1.063.54 1.17.568.112 2.023-.667 2.249-.333.193.286.31 1.008-.134 2.128-.744 1.875-3 4.688-2.495 4.212.83-.781 4.029-2.698 7.765-7.094 1.385-1.631.375-1.564.344-2.282z",
    id: "path5800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2268.712 578.312s1.296-2.919 1.133-3.373c-.154-.427-2.708 1.423-3.005 1.304-.286-.115-1.585.42-2.102.623-.508.2.861-1.705.21-1.187-.659.524-2.626 2.183-2.626 2.183l3.25 3.01z",
    id: "path5802"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g5819"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 2343.843,
    y1: 592.841,
    x2: 2343.843,
    y2: 591.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5812"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_101_)"
    },
    id: "polygon5815",
    d: "m2330.606 592.79 3.244-1.204h22.551l.663 1.204.015.028-22.145-.025z"
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5817",
    d: "M2330.606 592.79h26.458l.015.028.194.354h-26.667z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5830"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 2344.61,
    y1: 596.077,
    x2: 2344.61,
    y2: 594.774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5823"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_103_)"
    },
    id: "polygon5826",
    d: "m2330.365 596.022 3.243-1.204h24.57l.659 1.204.018.033-24.216-.029z"
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5828",
    d: "M2330.365 596.022h28.472l.018.033.195.349h-28.685z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5841"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 2346.46,
    y1: 599.31,
    x2: 2346.46,
    y2: 598.007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5834"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_105_)"
    },
    id: "polygon5837",
    d: "m2332.289 599.255 3.124-1.161.119-.043h24.422l.66 1.204.018.032-24.339-.029z"
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5839",
    d: "M2332.289 599.255h28.325l.018.032.194.35h-28.537z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5852"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 2348.482,
    y1: 602.542,
    x2: 2348.482,
    y2: 601.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5845"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5848",
    style: {
      fill: "url(#SVGID_106_)"
    },
    d: "m2334.556 602.487 3.243-1.204h23.932l.659 1.204.018.033-23.672-.029z"
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5850",
    d: "M2334.556 602.487h27.834l.018.033.191.349h-28.043z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5863"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 2268.762,
    y1: 591.046,
    x2: 2268.762,
    y2: 589.751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5856"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5859",
    style: {
      fill: "url(#SVGID_107_)"
    },
    d: "M2262.861 589.795h8.735l3.035 1.142.021.062.011.025-11.758-.015v-.01z"
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5861",
    d: "M2262.905 591.009v-.01h11.747l.011.025.13.357h-11.874z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5874"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 2269.418,
    y1: 594.282,
    x2: 2269.418,
    y2: 592.983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5867"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5870",
    style: {
      fill: "url(#SVGID_108_)"
    },
    d: "M2262.98 593.028h12.422l.443 1.203.011.029-12.833-.018v-.011z"
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5872",
    d: "M2263.023 594.242v-.011h12.822l.011.029.13.353h-12.948z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5885"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 2269.946,
    y1: 597.511,
    x2: 2269.946,
    y2: 596.216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5878"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5881",
    style: {
      fill: "url(#SVGID_109_)"
    },
    d: "m2276.458 597.489-13.316-.015v-.01l-.043-1.204h13.492l.202.544-.321.66z"
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5883",
    d: "M2276.285 597.846h-13.128l-.015-.372v-.01h13.33l-.014.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5896"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 2269.541,
    y1: 600.74,
    x2: 2269.541,
    y2: 599.448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    },
    id: "stop5887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a1a1a"
    },
    id: "stop5889"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon5892",
    style: {
      fill: "url(#SVGID_110_)"
    },
    d: "m2274.887 600.718-10.011-.011-.011-.011-1.269-1.204h11.889l-.588 1.204z"
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    id: "polygon5894",
    d: "M2274.714 601.078h-9.445l-.393-.371-.011-.011h10.032l-.01.022z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003TotalCarbon);
export default __webpack_public_path__ + "static/media/003-TotalCarbon.79314739b0c10174ae6f99abe180a388.svg";
export { ForwardRef as ReactComponent };